// import React, { useEffect, useState, useRef,useCallback  } from 'react'; 
// import { useParams, useNavigate } from 'react-router-dom'; 
// import socket from './socket';
// import './Board.css';
// import ShortBackgammonBoard from './ShortBackgammonBoard';
// import Modal from './Modal';
// import { useGame } from './context/GameContext';
// import axios from 'axios';
// import './Game.css';
// import './Board.css';


// const Game = ({ token }) => {
//   const { tableId } = useParams();
//   const navigate = useNavigate();
//   const {
//     game,setGame, updateGame,diceRolls, setDiceRolls, rollEnabled, setRollEnabled, readyStatus, updateReadyStatus,
//     firstRolls, setFirstRolls, currentTurn, setCurrentTurn, rollDiceEnabled, setRollDiceEnabled, confirmMoveEnabled, setConfirmMoveEnabled,
//     testik,flagFirst, setFlagFirst,setShowReadyButton,showReadyButton,openTablesCount, setOpenTablesCount, setTestik,dataLoaded,usedRolls, setUsedRolls,enteredCheckerData, setEnteredCheckerData,whiteOffBoard, setWhiteOffBoard,blackOffBoard, setBlackOffBoard,capturedCheckers, setCapturedCheckers,moveHistory, setMoveHistory, setDataLoaded,isFirstMoveDone, setIsFirstMoveDone,firstRollComplete,setFirstRollComplete,numberMove, setNumberMove, playerColor, setPlayerColor, turnCompleted,firstMoveComplete, setFirstMoveComplete, setTurnCompleted,rolledDice, setRolledDice, currentTableId, setCurrentTableId,tableStates, setTableStates
//   } = useGame();

  
//   const [moves, setMoves] = useState([]);
//   const [timer, setTimer] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [countdown, setCountdown] = useState(10);
//   // const [showReadyButton, setShowReadyButton] = useState(false);
//   const [opponentName, setOpponentName] = useState('Ожидание второго игрока');
//    // useRef для хранения идентификатора интервала
//    const countdownInterval = useRef(null);
//    const [isTestikLoaded, setIsTestikLoaded] = useState(false); // Новый флаг
//    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
//    const [flagTestik, setFlagTestik] = useState(false);
//    const [test, setTest] = useState(false);
//    const [shetchik, setShetchik] = useState(() => {
//     const savedValue = localStorage.getItem('shetchik');
//     return savedValue ? parseInt(savedValue, 10) : 0;
//   });
//   const [hasRolledDice, setHasRolledDice] = useState(false)
//   const [flagButtonFirst, setFlagButtonFirst] = useState(0)
//   const { tableId: routeTableId } = useParams(); // Получаем tableId из URL
 





//   // const [hasRolledDice, setHasRolledDice] = useState(() => {
//   //   const savedValueHasRolledDice = localStorage.getItem('hasRolledDice');
//   //   return savedValueHasRolledDice ? savedValueHasRolledDice === 'false' : true;
//   // });
  

//   //  const [hasJoinedTable, setHasJoinedTable] = useState(false);
//   const username = localStorage.getItem('username');
 
//   const didMountRef = useRef(false);
//   // Используем useRef вместо useState для отслеживания отправки joinTable
//   const hasJoinedTableRef = useRef(false);

//   const requestCountRef = useRef(0);

// //Основ до о1
// // useEffect(() => {
// //   socket.on("gameDataResponse", (gameData) => {
// //     if (!gameData) {
// //       console.error("Данные игры не найдены");
// //       return;
// //     }

    
// //     updateGame(gameData);

// //     // Устанавливаем текущий ход
// //     setCurrentTurn(gameData.current_turn);
// //     setNumberMove(gameData.numberMovePlayer1)
// //     console.log('44444',numberMove);
    
// //     // Определяем цвет игрока
// //     let playerColorLocal = null;
// //     if (gameData.player1_name === username) {
// //       playerColorLocal = "white";
// //     } else if (gameData.player2_name === username) {
// //       playerColorLocal = "black";
// //     }
// //     setPlayerColor(playerColorLocal);

// //     // Проверка, бросил ли игрок кубики
// //     let hasRolled = false;
// //     let lastRoll = [];
// //     const playerRolls =
// //       playerColorLocal === "white" ? gameData.player1_rolls : gameData.player2_rolls;

// //     if (playerRolls) {
// //       const rolls = JSON.parse(playerRolls);
// //       lastRoll = rolls.length ? rolls[rolls.length - 1] : [];
// //       hasRolled = rolls.length > 0 && Array.isArray(rolls[rolls.length - 1]);
// //     }

// //     setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
// //     setHasRolledDice(hasRolled);

// //     // Устанавливаем количество ходов
// //     const movesCount = lastRoll[0] === lastRoll[1] ? 4 : 2;
// //     setNumberMove(lastRoll.length > 0 ? movesCount : 2);

// //     // Восстанавливаем значение `testik` для текущего игрока
// //     if (!gameData.firstMoveComplete) {
// //       // Если первый ход еще не завершен  !!!!!!!!!!!!! Если раскоментить то после первого хода скрывается кнопка но после обновления она пропадает
// //       // setTestik(true); // Скрыть кнопку "Бросить кубики"
// //     } else {
// //       const isMyTurn = gameData.current_turn === (playerColorLocal === 'white' ? 'player1' : 'player2');
// //       // Показать кнопку, если это мой ход и кубики еще не были брошены
// //       setTestik(!(isMyTurn && !hasRolled));
// //     }

  
// //   });

// //   return () => {
// //     socket.off("gameDataResponse");
// //   };
// // }, [tableId, username,numberMove]);


// // useEffect(() => {
// //   socket.on('gameAlreadyExists', ({ tableId }) => {
// //     alert(`Игра для стола ${tableId} уже существует. Пожалуйста, присоединитесь к существующей игре.`);
// //     navigate('/'); // При необходимости перенаправьте пользователя на другую страницу
// //   });

// //   return () => {
// //     socket.off('gameAlreadyExists');
// //   };
// // }, []);





// // useEffect(() => {
// //   if (!socket.connected) {
// //     socket.connect();
// //   }

// //   if (!hasJoinedTableRef.current && socket.connected) {
// //     hasJoinedTableRef.current = true;
// //     console.log('Отправка запроса joinTable');
// //     console.log('Флаг hasJoinedTableRef после отправки:', hasJoinedTableRef.current);

// //     socket.emit('joinTable', { tableId, player: username });
// //   }
// // }, [tableId, username]);
//   // useEffect для инициализации currentTableId из маршрута



//   const useCapturedCheckers = (setCapturedCheckers) => {
//     useEffect(() => {
//       const handleCapturedCheckersUpdate = (data) => {
//         console.log("Получены данные о захваченных шашках:", data);
  
//         // Проверяем, относится ли обновление к текущему столу
//         if (localStorage.getItem("currentTableId") === String(data.tableId)) {
//           setCapturedCheckers(data.capturedCheckers);
//         }
//       };
  
//       // Подписываемся на событие capturedCheckersUpdate
//       socket.on("capturedCheckersUpdate", handleCapturedCheckersUpdate);
  
//       return () => {
//         // Отписываемся при размонтировании
//         socket.off("capturedCheckersUpdate", handleCapturedCheckersUpdate);
//       };
//     }, [setCapturedCheckers]);
//   };







//   useEffect(() => {
//     if (routeTableId) {
//       setCurrentTableId(routeTableId); // Обновляем currentTableId из URL при загрузке
//       localStorage.setItem('currentTableId', routeTableId); // Сохраняем в localStorage
//       console.log('currentTableId установлено из маршрута:', routeTableId); // Логируем установку из маршрута
//     }
//   }, [routeTableId]);




//  // useEffect для синхронизации currentTableId с localStorage и логирования
//  useEffect(() => {
//   if (currentTableId) {
//     localStorage.setItem('currentTableId', currentTableId); // Сохраняем в localStorage
//     console.log('currentTableId обновлён:', currentTableId); // Логируем обновление
//   }
// }, [currentTableId]); // Зависимость от currentTableId

// // useEffect для обработки событий 'diceDataResponse'
// // useEffect(() => {
// //   const handleDiceDataResponse = (data) => {
// //     console.log("000909090", data);

// //     const isMyTurn = data.current_turn === (playerColor === "white" ? "player1" : "player2");
// //     if (isMyTurn) {
// //       const myRolls = playerColor === "white" ? data.player1_rolls : data.player2_rolls;
// //       const lastRoll = myRolls[myRolls.length - 1] || [];
// //       setRolledDice(lastRoll);
// //       console.log("Мой ход, кубики:", lastRoll);
// //     } else {
// //       const opponentRolls = playerColor === "white" ? data.player2_rolls : data.player1_rolls;
// //       const lastRoll = opponentRolls[opponentRolls.length - 1] || [];
// //       setRolledDice(lastRoll);
// //       console.log("Ход оппонента, кубики:", lastRoll);
// //     }
// //   };

// //   // Подписка на событие 'diceDataResponse'
// //   socket.on("diceDataResponse", handleDiceDataResponse);
// //   console.log("Подписались на 'diceDataResponse'");

// //   // Эмитируем 'fetchDiceData' после установки слушателя
// //   if (currentTableId) {
// //     console.log("Отправляем fetchDiceData с ID:", currentTableId);
// //     socket.emit("fetchDiceData", currentTableId);
// //   }

// //   return () => {
// //     // Отписка от события 'diceDataResponse' при размонтировании компонента
// //     socket.off("diceDataResponse", handleDiceDataResponse);
// //     console.log("Отписались от 'diceDataResponse'");
// //   };
// // }, [currentTableId, playerColor]); // Зависимости
// useEffect (()=>{
//   console.log('tyutyjtu',rolledDice);
  
// },[rolledDice])






// // useEffect(() => {
// //   localStorage.setItem("showReadyButton", JSON.stringify(showReadyButton));
// // }, [showReadyButton]);

// // useEffect(() => {
// // if (game?.player1_name && game?.player2_name && !readyStatus.player1 && !readyStatus.player2) {
// //     setShowReadyButton(true); // Показываем кнопку, если оба игрока присутствуют
// // }
// // }, [game, readyStatus]);
// // useEffect(() => {
// //   const handleDiceDataResponse = (data) => {
// //     console.log("Получены данные в diceDataResponse:", data);

// //     const isMyTurn = data.current_turn === (playerColor === "white" ? "player1" : "player2");
// //     const rolls = isMyTurn
// //       ? playerColor === "white" ? data.player1_rolls : data.player2_rolls
// //       : playerColor === "white" ? data.player2_rolls : data.player1_rolls;

// //     const lastRoll = rolls[rolls.length - 1] || [];
// //     // setRolledDice(lastRoll);
// //     setRolledDice([...lastRoll]); // Создаем новый массив, чтобы React понял, что состояние изменилось

// //     console.log(isMyTurn ? "Мой ход, кубики:" : "Ход оппонента, кубики:", {
// //       rolls,
// //       lastRoll,
// //     });
// //   };

// //   socket.on("diceDataResponse", handleDiceDataResponse);
// //   console.log("Подписались на 'diceDataResponse'");

// //   if (currentTableId) {
// //     console.log("Отправляем fetchDiceData с ID:", currentTableId);
// //     socket.emit("fetchDiceData", currentTableId);
// //   }

// //   return () => {
// //     socket.off("diceDataResponse", handleDiceDataResponse);
// //     console.log("Отписались от 'diceDataResponse'");
// //   };
// // }, [currentTableId, playerColor]);
// // Вне useEffect создаем мемоизированную функцию
// const handleDiceDataResponse = useCallback(
//   (data) => {
//     console.log("Получены данные в diceDataResponse:", data);

//     const isMyTurn =
//       data.current_turn === (playerColor === "white" ? "player1" : "player2");
//     const rolls = isMyTurn
//       ? playerColor === "white" ? data.player1_rolls : data.player2_rolls
//       : playerColor === "white" ? data.player2_rolls : data.player1_rolls;

//     const lastRoll = rolls[rolls.length - 1] || [];
//     // Создаем новый массив, чтобы React понял, что состояние изменилось
//     setRolledDice([...lastRoll]);

//     console.log(isMyTurn ? "Мой ход, кубики:" : "Ход оппонента, кубики:", {
//       rolls,
//       lastRoll,
//     });
//   },
//   [playerColor] // Зависимости, которые определяют, когда мемоизация должна быть пересчитана
// );



// // const handleCollapse = () => {
// //   console.log("Свернули стол вручную:", tableId);

// //   // Обновляем состояние: стол свернут
// //   updateTableState(tableId, { isMinimized: true, isClosed: false });

// //   // Переход в лобби
// //   navigate('/');
// // };
// const handleCollapse = () => {
//   console.log("Свернули стол вручную:", tableId);

//   // Обновляем состояние: стол свернут
//   const updatedTableStates = {
//     ...tableStates,
//     [tableId]: { ...tableStates[tableId], isMinimized: true, isClosed: false },
//   };

//   setTableStates(updatedTableStates);
//   localStorage.setItem('tableStates', JSON.stringify(updatedTableStates));

//   // Переход в лобби
//   navigate('/');
// };


// const updateTableState = (tableId, updates) => {
//   setTableStates((prev) => {
//     const currentState = prev[tableId] || {};
//     const newState = { ...currentState, ...updates };

//     if (JSON.stringify(currentState) === JSON.stringify(newState)) {
//       console.log(`Состояние для стола ${tableId} не изменилось, пропускаем обновление.`);
//       return prev;
//     }

//     console.log(`Обновляем состояние для стола ${tableId}:`, newState);
//     return {
//       ...prev,
//       [tableId]: newState,
//     };
//   });
// };



// // useEffect(() => {
// //   setCurrentTableId(tableId); // Сохраняем ID текущего стола при заходе
// //   console.log("Выходим со стола:", tableId);
// //   return () => setCurrentTableId(tableId); // Очищаем ID стола при выходе
  
// // }, [tableId, setCurrentTableId]);


// // useEffect(() => {
// //   console.log("Зашли за стол:", tableId);
  
// //   // Сохраняем ID текущего стола при входе
// //   setCurrentTableId(tableId);

// //   return () => {
// //     // Проверяем, закрыт стол или свернут
// //     if (window.location.pathname.includes('/game')) {
// //       setCurrentTableId(tableId); // Если свернули, сохраняем ID
// //     } else {
// //       setCurrentTableId(tableId); // Если вышли, очищаем ID
// //     }
// //   };
// // }, [tableId, setCurrentTableId]);
// useEffect(() => {
//   console.log("Зашли за стол:", tableId);

//   updateTableState(tableId, { isClosed: false, isMinimized: false });

//   return () => {
//     const fromGame = window.history.state?.usr?.fromGame || false;
//     if (fromGame) {
//       console.log("Закрыли стол:", tableId);
//       updateTableState(tableId, { isClosed: true, isMinimized: false });
//     } else {
//       console.log("Свернули стол:", tableId);
//       updateTableState(tableId, { isMinimized: true, isClosed: false });
//     }
//   };
// }, [tableId]);





// useEffect(() => {
//   if(shetchik <=2){ 
//     setDataLoaded(true)
//   }
//   else {
//     setDataLoaded(false)
//   }
// }, [shetchik,dataLoaded]);

// useEffect(() => {
//   localStorage.setItem('shetchik', shetchik);
// }, [shetchik]);


// useEffect(() => {
//  console.log('history',moveHistory);
 
// }, [moveHistory]);

 

// // useEffect(() => {
// //   console.log('Сохранение hasRolledDice в localStorage:', hasRolledDice);
// //   localStorage.setItem('hasRolledDice', hasRolledDice.toString());
// // }, [hasRolledDice]);




// useEffect(() => {
//   const handleConnect = () => {
//     console.log('Сокет подключен');
//      socket.emit('joinTable', { tableId, player: username });
//     console.log(`Соединение установлено, отправлено событие joinTable для пользователя ${username} и стола ${tableId}`);
//   };

//   // if (socket.connected) {
//   //   console.log('Сокет уже подключен');
//   //   socket.emit('joinTable', { tableId, player: username });
//   //   console.log(`Отправлено событие joinTable для пользователя ${username} и стола ${tableId}`);
//   // } else {
//   //   console.log('Сокет не подключен, устанавливаем обработчик connect и вызываем socket.connect()');
//   //   socket.on('connect', handleConnect);
//   //   socket.connect();
//   // }

//   return () => {
//     socket.off('connect', handleConnect);
//   };
// }, [tableId, username]);


// useEffect (()=>{
// console.log('цвет1',playerColor);

// },[playerColor])


  


//   // useEffect (()=>{
//   //   console.log('player2FirstRollEnabled1111',  rollEnabled);
    
//   //   },[ rollEnabled])

// // До о1
// useEffect(() => {
//   socket.on("gameDataResponse", (gameData) => {
//     setMoveHistory([]); // Очищаем историю ходов
//     console.log('33332222',gameData,numberMove);
//     setDataLoaded(true);
//     if (!gameData) {
//       console.error("Данные игры не найдены");
//       return;
//     }
  
//     let playerColorLocal = null;
// if (gameData.player1_name === username) {
//   playerColorLocal = "white";
// } else if (gameData.player2_name === username) {
//   playerColorLocal = "black";
// }
// console.log('цвет',playerColorLocal);

// setPlayerColor(playerColorLocal);
// // Обновляем состояния броска кубиков
//    // Восстанавливаем убитые шашки
//    const capturedCheckers = gameData.captured_checkers || { white: 0, black: 0 };
//    setCapturedCheckers(capturedCheckers);
//    console.log('Установлены убитые шашки:', capturedCheckers);

//    // Восстанавливаем выведенные шашки
//    const whiteOffBoard = gameData.white_off_board || [];
//    const blackOffBoard = gameData.black_off_board || [];
//    setWhiteOffBoard([...whiteOffBoard]);
//    setBlackOffBoard([...blackOffBoard]);
//    console.log('Установлены выведенные шашки:', { whiteOffBoard, blackOffBoard });
  
   





//   // Логирование данных перед установкой состояний
//   console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
// // Обновление состояния hasRolledDice на основе данных из игры
// if (playerColorLocal === "white") {
//   setHasRolledDice(gameData.hasRolledDicePlayer1);
// } else if (playerColorLocal === "black") {
//   setHasRolledDice(gameData.hasRolledDicePlayer2);
// }

// setCurrentTurn(gameData.current_turn);


// // const hasRolledDicePlayer1 = gameData.hasRolledDicePlayer1 || false;
// // const hasRolledDicePlayer2 = gameData.hasRolledDicePlayer2 || false;

// // console.log('hasRolledDicePlayer1:', hasRolledDicePlayer1, 'hasRolledDicePlayer2:', hasRolledDicePlayer2);


// // if (playerColorLocal === "white") {
// //   if (hasRolledDicePlayer1) {
// //     setHasRolledDice(true);
// //     console.log('Player 1 уже бросил кубики');
// //   } else {
// //     setHasRolledDice(false);
// //     console.log('Player 1 еще не бросил кубики');
// //   }
// // } else if (playerColorLocal === "black") {
// //   if (hasRolledDicePlayer2) {
// //     setHasRolledDice(true);
// //     console.log('Player 2 уже бросил кубики');
// //   } else {
// //     setHasRolledDice(false);
// //     console.log('Player 2 еще не бросил кубики');
// //   }
// // }
// // console.log('Обновлено состояние hasRolledDice для текущего игрока:', hasRolledDice);








// // if (playerColorLocal === 'white') {
// //   setHasRolledDice(hasRolledDicePlayer1);
// // } else if (playerColorLocal === 'black') {
// //   setHasRolledDice(hasRolledDicePlayer2);
// // }
// //  console.log('Обновлено состояние hasRolledDice для текущего игрока:', hasRolledDice)
 
//    // Устанавливаем готовность игроков
  
//    const player1Ready = Boolean(gameData.player1_ready);
//    const player2Ready = Boolean(gameData.player2_ready);
//    updateReadyStatus('player1', player1Ready);
//    updateReadyStatus('player2', player2Ready);
  
//    console.log('Готовность игрока 1:', player1Ready, 'Готовность игрока 2:', player2Ready);
  
//    console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
  
   

  

// // Устанавливаем rollEnabled на основе firstRollComplete
//  if (!gameData.firstRollComplete) { 
// console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
//   // Первый бросок еще не завершен
//   if (playerColorLocal === "white") {
//     setRollEnabled(gameData.player1FirstRollEnabled);
//     console.log('432',gameData.player1FirstRollEnabled);
    
//   } else if (playerColorLocal === "black") {
//     setRollEnabled(gameData.player2FirstRollEnabled);
//     console.log('432',gameData.player1FirstRollEnabled);
//   }
// } else { 
//   // Первый бросок завершен, кнопка не должна отображаться
//   setRollEnabled(false); 
// }
// // Обновляем firstRollComplete
// setFirstRollComplete(gameData.firstRollComplete);

// // Обновляем состояние игры  это предложил 40 -0 но не работает, возможно надо удалить  комент
// // if (gameData) {
// //   setGame(gameData);
// //   console.log('Состояние игры обновлено с сервера:', gameData);
// // }
// console.log('Состояние игры обновлено с сервера:', gameData);
// // до сюда удалить

// console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
//     // Восстанавливаем значения кубиков
//     const playerRolls1 = {
//       white: gameData.player1_rolls || [],
//       black: gameData.player2_rolls || [],
//     };

//     const myRolls = playerRolls1[playerColorLocal] || [];
//     const lastRoll1 = myRolls.length > 0 ? myRolls[myRolls.length - 1] : [];
//     // setRolledDice(lastRoll1);
//     console.log('кубики обонова',lastRoll1,myRolls,gameData.player1_rolls, gameData.player2_rolls);
    

//     // setHasRolledDice(lastRoll1.length > 0);
//     // console.log('5756', rolledDice, hasRolledDice, myRolls);

// // Устанавливаем текущий ход
// setCurrentTurn(gameData.current_turn);


// console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
// if (playerColorLocal === "white") {
//   console.log('1111111',playerColorLocal);
//   // console.log('первый ход',gameData.player1FirstRollEnabled);
  
//   setNumberMove(gameData.numberMovePlayer1);
//  console.log('пришли кубики',numberMove);
 

// } else if (playerColorLocal === "black") {
//   // console.log('первый ход',gameData.player2FirstRollEnabled);
//   setNumberMove(gameData.numberMovePlayer2);
//   console.log('пришли кубики',numberMove);
  
// }


// let hasRolled = false;
// let lastRoll = [];
// const playerRolls =
//   playerColorLocal === "white" ? gameData.player1_rolls : gameData.player2_rolls;
// console.log('плеер',playerColorLocal);

// if (playerRolls) {
//   let rolls;
//   if (typeof playerRolls === 'string' && playerRolls !== '') {
//     try {
//       rolls = JSON.parse(playerRolls);
//     } catch (error) {
//       console.error('Ошибка при парсинге playerRolls:', error);
//       rolls = [];
//     }
//   } else if (Array.isArray(playerRolls)) {
//     rolls = playerRolls;
//   } else {
//     rolls = [];
//   }

//   // Используем просто проверку на наличие элементов в массиве
//   lastRoll = rolls.length ? rolls[rolls.length - 1] : [];
//   hasRolled = rolls.length > 0; // Здесь мы устанавливаем булевое значение

// } else {
//   lastRoll = [];
//   hasRolled = false;
// }

// // setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
// // Устанавливаем только если это наш ход
// const isMyTurn = gameData.current_turn === (playerColorLocal === "white" ? "player1" : "player2");

// if (isMyTurn) {
//   setRolledDice(Array.isArray(lastRoll) ? [...lastRoll] : []);
// }

// console.log("Обновлены кубики:", {
//   lastRoll,
//   isMyTurn,
// });

// // Обновляем состояние firstRolls для первого броска каждого игрока

// // Обновляем состояние firstRolls для первого броска каждого игрока
// let player1Rolls = [];
// let player2Rolls = [];



// try {
//   if (gameData.player1_rolls && typeof gameData.player1_rolls === 'string' && gameData.player1_rolls.trim() !== "") {
//     player1Rolls = JSON.parse(gameData.player1_rolls);
   
//   } else if (Array.isArray(gameData.player1_rolls)) {
//     player1Rolls = gameData.player1_rolls;
//   }
// } catch (error) {
//   console.error('Ошибка при парсинге player1_rolls:', error);
//   player1Rolls = [];
// }

// try {
//   if (gameData.player2_rolls && typeof gameData.player2_rolls === 'string' && gameData.player2_rolls.trim() !== "") {
//     player2Rolls = JSON.parse(gameData.player2_rolls);
    
//   } else if (Array.isArray(gameData.player2_rolls)) {
//     player2Rolls = gameData.player2_rolls;
//   }
// } catch (error) {
//   console.error('Ошибка при парсинге player2_rolls:', error);
//   player2Rolls = [];
// }





// // Если первый ход еще не завершен, объединяем значения кубиков для первого броска
//     if (!gameData.firstMoveComplete) {
//       if (player1Rolls.length > 0 && player2Rolls.length > 0) {
//         // Определяем победителя первого броска
//         const player1FirstRoll = player1Rolls[0];
//         const player2FirstRoll = player2Rolls[0];

//         let firstMoveRolls;
//         if (player1FirstRoll > player2FirstRoll) {
//           firstMoveRolls = playerColorLocal === 'white' ? [player1FirstRoll, player2FirstRoll] : [];
//         } else if (player2FirstRoll > player1FirstRoll) {
//           firstMoveRolls = playerColorLocal === 'black' ? [player2FirstRoll, player1FirstRoll] : [];
//         } else {
//           // В случае равенства нужно переиграть, но для текущей логики просто пропускаем
//           firstMoveRolls = [];
//         }
//         console.log("player2FirstRollEnabled перед установкой:",gameData.player1FirstRollEnabled, gameData.player2FirstRollEnabled);
//         setRolledDice(firstMoveRolls);
//         console.log('rolledDice обновлен для первого хода:', firstMoveRolls);
//       }
//     } else {
//       // Если первый ход завершен, восстанавливаем обычные броски
//       let playerRolls = playerColorLocal === 'white' ? player1Rolls : player2Rolls;
//       const lastRoll = playerRolls.length > 0 ? playerRolls[playerRolls.length - 1] : [];
//       // setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
      
//     }

//     // Обновляем состояние firstRolls для первого броска каждого игрока
//     setFirstRolls({
//       player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
//       player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
//     });
//     console.log('Обновлены значения firstRolls:', {
//       player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
//       player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
//     });

//     // Устанавливаем текущий ход
//     setCurrentTurn(gameData.current_turn);


   




// setFirstRolls({
//   player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
//   player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
// });
// console.log('Обновлены значения firstRolls:', {
//   player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
//   player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
// });


// // setHasRolledDice(hasRolled);

// console.log('rolledDice после обновления:', rolledDice, hasRolled);

//    // Устанавливаем текущий ход
//    setCurrentTurn(gameData.current_turn);
 
//     updateGame(gameData);
//     console.log('33332222',gameData);


 

   

   









  
//     // setUsedRolls([]);
//     // console.log('rolledDice после обновления:', hasRolledDice,hasRolled);

//     // Устанавливаем количество ходов
//     // Устанавливаем количество оставшихся ходов из базы данных
// if (playerColorLocal === 'white') {
//   setNumberMove(gameData.numberMovePlayer1 || 0);
//   console.log('Установлено numberMove из базы данных для белых:', gameData.numberMovePlayer1);
// } else if (playerColorLocal === 'black') {
//   setNumberMove(gameData.numberMovePlayer2 || 0);
//   console.log('Установлено numberMove из базы данных для чёрных:', gameData.numberMovePlayer2);
// }



//     // Восстанавливаем значение `testik` для текущего игрока
//     if (!gameData.firstMoveComplete) {
//       setRollDiceEnabled(true);
//     } else {
//       const isMyTurn = gameData.current_turn === (playerColorLocal === 'white' ? 'player1' : 'player2');
//       // setTestik(!(isMyTurn && !hasRolledDice));
//       setRollDiceEnabled(true);
//     }
    
//   });


//   return () => {
//     socket.off("gameDataResponse");
//   };
// }, [tableId, username]);





// useEffect(()=>{
//   console.log('смотрим',rollEnabled);
// },[rollEnabled])

// useEffect(() => {
//   const loadGameData = () => {
//     // Запрос данных игры по сокетам
    
//     socket.emit('fetchGameData', tableId);

//     socket.on('gameDataResponse', (gameData) => {
     
      
//       // Установка начального значения testik из базы данных
      
//       // if (playerColor === 'white' ) {
//       //   setRollEnabled(gameData.player1FirstRollEnabled || false);
//       // } else if (playerColor === 'black') {
//       //   setRollEnabled(gameData.player2FirstRollEnabled || false);
//       // }

//       // Завершение первичной загрузки
//       // setInitialLoadCompleted(true);
     

//     }); 
//   };

//    loadGameData();

//   // Чистим слушатель при размонтировании, чтобы не допустить утечек
//   return () => socket.off('gameDataResponse');
// }, [tableId, playerColor]);



// //До обновления о1
// // useEffect(() => {
// //   if (initialLoadCompleted) {
// //     socket.emit('updateTestik', { tableId, testik, player: playerColor === 'white' ? 'player1' : 'player2' }, (response) => {
     
// //     });
// //   }
// // }, [testik, tableId, playerColor, initialLoadCompleted]);
// useEffect(() => {
//   if (initialLoadCompleted) {
//     // Отправляем testik на сервер
//     socket.emit('updateTestik', { 
//       tableId, 
//       testik, 
//       player: playerColor === 'white' ? 'player1' : 'player2' 
//     }, (response) => {
//       // Обработка ответа, если необходимо
//     });

//     // Отправляем rollEnabled на сервер
//      updateFirstRollEnabledOnServer(rollEnabled);
//   }
// }, [testik, tableId, playerColor, initialLoadCompleted]);




// // Добавляем проверку и лог для каждого обновления testik
// useEffect(() => {
  

//   const playerKey = playerColor === "white" ? "player1" : "player2";
//   // console.log(`Подготовка к отправке testik на сервер через сокет:`, {
//   //   tableId,
//   //   testik,
//   //   player: playerKey,
//   // });

//   // Отправка через сокет с логом для проверки на клиенте
//   socket.emit(
//     "updateTestik",
//     {
//       tableId,
//       testik,
//       player: playerKey,
//     },
//     (response) => {
       
//     }
//   );
// }, [testik, tableId, playerColor]);





// useEffect(() => {
  
// console.log('24523424',tableStates);

// }, [tableStates]);
// //Закоментил 24 ноября не понимаю что делает этот код
// // useEffect(() => {
// //   socket.on("testikUpdated", (data) => {
// //     const { player, testik: newTestik } = data;
// //     if (player === (playerColor === "white" ? "player1" : "player2")) {
// //       setTestik(newTestik);
// //       // console.log("Значение testik обновлено из сокета:", newTestik);
// //     }
// //   });

// //   return () => {
// //     socket.off("testikUpdated");
// //   };
// // }, [playerColor]);





// useEffect(() => {
//   // Устанавливаем флаг для отслеживания первого вызова
//   let isInitialLoad = true;

//   if (!socket.connected) {
//     socket.connect();
//   }

//   const handleGameData = (gameData) => {
//     if (isInitialLoad) {
     
//       updateGame(gameData); // Обновление состояния игры только при первом получении данных
//       isInitialLoad = false; // После первого вызова сбрасываем флаг
//     }
//   };

//   socket.once('connect', () => {
//     // Запрашиваем данные игры только один раз при подключении
//     socket.emit('fetchGameData', tableId);
//   });

//   socket.on('gameDataResponse', handleGameData);

//   return () => {
//     socket.off('gameDataResponse', handleGameData);
//   };
// }, [tableId]);












// useEffect(() => {
//   socket.on('startCountdown', ({ tableId }) => {
//     console.log('Событие startCountdown получено:', tableId);

//     if (parseInt(tableId, 10) === parseInt(currentTableId, 10)) {
//       console.log('server tableId =', tableId, 'client currentTableId =', currentTableId);


//       // Сбрасываем предыдущий интервал, если он существует
//       if (countdownInterval.current) {
//         console.log('Очистка старого интервала:', countdownInterval.current);
//         clearInterval(countdownInterval.current);
//         countdownInterval.current = null;
//       }

//       // Устанавливаем начальное значение отсчета
//       setCountdown(10);

//       // Создаем новый интервал
//       countdownInterval.current = setInterval(() => {
//         console.log('Интервал сработал');
//         setCountdown((prevCountdown) => {
//           console.log('Обновление отсчёта:', prevCountdown);
//           if (prevCountdown <= 1) {
//             clearInterval(countdownInterval.current);
//             countdownInterval.current = null;
//             console.log('Таймер завершен');
//             return 0;
//           }
//           return prevCountdown - 1;
//         });
//       }, 1000);

//       console.log('countdownInterval установлен после setInterval:', countdownInterval.current);
//     }
//   });

//   return () => {
//     socket.off('startCountdown');
//     if (countdownInterval.current) {
//       clearInterval(countdownInterval.current);
//       countdownInterval.current = null;
//     }
//   };
// }, [currentTableId]);
// // useEffect(() => {
// //   console.log('useEffect startCountdown: currentTableId =', currentTableId);

// //   const listener = (data) => {
// //     console.log('Пришло startCountdown:', data.tableId);
// //     console.log(
// //       'Сравниваем parseInt(data.tableId) =',
// //       parseInt(data.tableId, 10),
// //       'и parseInt(currentTableId) =',
// //       parseInt(currentTableId, 10)
// //     );

// //     if (parseInt(data.tableId, 10) === parseInt(currentTableId, 10)) {
// //       console.log('Условие совпало, запускаем setInterval');
// //       setCountdown(10);

// //       // Очищаем старый
// //       if (countdownInterval.current) {
// //         clearInterval(countdownInterval.current);
// //       }

// //       countdownInterval.current = setInterval(() => {
// //         console.log('setInterval сработал');
// //         setCountdown((prev) => {
// //           if (prev <= 1) {
// //             clearInterval(countdownInterval.current);
// //             countdownInterval.current = null;
// //             console.log('Таймер завершен');
// //             return 0;
// //           }
// //           return prev - 1;
// //         });
// //       }, 1000);
// //     } else {
// //       console.log('Условие НЕ совпало, значит не наш стол');
// //     }
// //   };

// //   socket.on('startCountdown', listener);

// //   return () => {
// //     console.log("UNMOUNT -> очищаем интервал", countdownInterval.current);
// //     socket.off('startCountdown', listener);
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //       countdownInterval.current = null;
// //     }
// //   };
// // }, [currentTableId]);









// // useEffect(() => {
// //   function handleStartCountdown({ tableId: fromServer }) {
// //     console.log('startCountdown event received:', fromServer);

// //     if (+fromServer !== +currentTableId) return;
// //     console.log('startCountdown: set countdown=10');
// //     setCountdown(10);

// //     // Очищаем старый интервал, если есть
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //     }

// //     // Запускаем новый
// //     countdownInterval.current = setInterval(() => {
// //       setCountdown(prev => {
// //         if (prev <= 1) {
// //           clearInterval(countdownInterval.current);
// //           countdownInterval.current = null;
// //           console.log('Таймер закончился');
// //           return 0;
// //         }
// //         return prev - 1;
// //       });
// //     }, 1000);
// //   }

// //   socket.on('startCountdown', handleStartCountdown);

// //   return () => {
// //     socket.off('startCountdown', handleStartCountdown);
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //       countdownInterval.current = null;
// //     }
// //   };
// // }, [currentTableId]);



// // useEffect(() => {
// //   function handleStartCountdown({ tableId: fromServer }) {
// //     // Проверяем, наш ли это стол
// //     if (parseInt(fromServer, 10) !== parseInt(currentTableId, 10)) return;

// //     console.log('startCountdown получен, ставим setCountdown(10)');
// //     setCountdown(10);

// //     // Очищаем старый интервал, если есть
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //     }
// //     // Запускаем новый
// //     countdownInterval.current = setInterval(() => {
// //       setCountdown((prev) => {
// //         if (prev <= 1) {
// //           clearInterval(countdownInterval.current);
// //           countdownInterval.current = null;
// //           console.log('Таймер закончился');
// //           return 0;
// //         }
// //         return prev - 1;
// //       });
// //     }, 1000);
// //   }

// //   socket.on('startCountdown', handleStartCountdown);

// //   return () => {
// //     socket.off('startCountdown', handleStartCountdown);
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //       countdownInterval.current = null;
// //     }
// //   };
// // }, [currentTableId]);















// // useEffect(() => {
// //   const handleStartCountdown = (data) => {
// //     setCountdown(10);
// //     // Очищаем старый интервал, если вдруг остался
// //     if (countdownInterval.current) clearInterval(countdownInterval.current);

// //     // Запускаем новый
// //     countdownInterval.current = setInterval(() => {
// //       setCountdown((prev) => {
// //         if (prev <= 1) {
// //           clearInterval(countdownInterval.current);
// //           countdownInterval.current = null;
// //           return 0;
// //         }
// //         return prev - 1;
// //       });
// //     }, 1000);
// //   };

// //   // Подписываемся
// //   socket.on('startCountdown', handleStartCountdown);

// //   // Очистка подписок
// //   return () => {
// //     socket.off('startCountdown', handleStartCountdown);
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //     }
// //   };
// // }, []);





// useEffect(() => {
//   const handleResetCountdown = (data) => {
//     // Проверяем, что пришли корректные данные от сервера
//     if (data && data.tableId) {
//       const { tableId } = data;

//       // Определяем, готов ли текущий игрок
//       const currentPlayerKey = playerColor === 'white' ? 'player1' : 'player2';
//       const iAmReady = readyStatus[currentPlayerKey]; // true или false

//       // Если я НЕ готов — закрываю стол у себя
//       if (!iAmReady) {
//         // 1. Делаем -1 в таблице Users
//         socket.emit('decrementOpenTableCount', { tableId, username });

//         // 2. Удаляем запись о столе из tableStates
//         setTableStates((prev) => {
//           const updated = { ...prev };
//           // На всякий случай уменьшаем локальный счётчик, если он есть
//           setOpenTablesCount((prevCount) => Math.max(prevCount - 1, 0));

//           // Удаляем сам стол
//           delete updated[tableId];
//           localStorage.setItem('tableStates', JSON.stringify(updated));
//           return updated;
//         });

//         // 3. Проверяем, если это текущий стол, сбрасываем состояние
//         if (parseInt(tableId, 10) === parseInt(currentTableId, 10)) {
//           if (countdownInterval.current) {
//             clearInterval(countdownInterval.current);
//             countdownInterval.current = null;
//           }

//           setCountdown(0);
//           setOpponentName('Ожидание второго игрока');
//           navigate('/'); // Выкидываем в лобби

//           // 4. Обновляем состояние игры: у оставшегося игрока очищаем второго
//           updateGame((prevGame) => {
//             if (prevGame) {
//               if (prevGame.player1_name === username) {
//                 return { ...prevGame, player2_name: '' };
//               } else if (prevGame.player2_name === username) {
//                 return { ...prevGame, player1_name: '' };
//               }
//             }
//             return prevGame;
//           });
//         }
//       } else {
//         // Я Готов — у меня стол не закрываем и -1 не делаем
//         console.log('Я нажал "Готов", стол у меня не закрываем и openTableCount не уменьшаем');
//       }
//     } else {
//       console.warn('Получены некорректные данные для resetCountdown:', data);
//     }
//   };

//   // Подписываемся на событие resetCountdown
//   socket.on('resetCountdown', handleResetCountdown);

//   return () => {
//     // Отписываемся от события и очищаем интервал
//     socket.off('resetCountdown', handleResetCountdown);
//     if (countdownInterval.current) {
//       clearInterval(countdownInterval.current);
//       countdownInterval.current = null;
//     }
//   };
// }, [
//   currentTableId,
//   username,
//   playerColor,
//   readyStatus,
//   navigate,
//   setTableStates,
//   setOpenTablesCount,
//   updateGame
// ]);









// // useEffect(() => {
// //   const handleResetCountdown = (data) => {
// //     // Проверяем, что пришли корректные данные от сервера
// //     if (data && data.tableId) {
// //       const { tableId } = data;

// //       // Вызываем событие уменьшения openTableCount на сервере (Задание №1)
// //       socket.emit('decrementOpenTableCount', { tableId, username });

// //       // Определяем, готов ли текущий игрок
// //       const currentPlayerKey = (playerColor === 'white') ? 'player1' : 'player2';
// //       const iAmReady = readyStatus[currentPlayerKey]; // true или false

// //       // Если я НЕ готов — закрываю стол у себя
// //       if (!iAmReady) {
// //         setTableStates((prev) => {
// //           const updated = { ...prev };
// //           // Уменьшаем счётчик открытых столов
// //           setOpenTablesCount((prevCount) => Math.max(prevCount - 1, 0));
// //           // Удаляем запись о столе
// //           delete updated[tableId];
// //           // Сохраняем изменения в localStorage
// //           localStorage.setItem('tableStates', JSON.stringify(updated));
// //           return updated;
// //         });

// //         // Проверяем, если это наш текущий стол — сбрасываем состояние
// //         if (parseInt(tableId, 10) === parseInt(currentTableId, 10)) {
// //           if (countdownInterval.current) {
// //             clearInterval(countdownInterval.current);
// //             countdownInterval.current = null;
// //           }

// //           setCountdown(0);
// //           setOpponentName('Ожидание второго игрока');
// //           navigate('/'); // Выходим (или выкидываем) в лобби

// //           // Обновляем состояние игры (очищаем второго игрока у того, кто остался)
// //           updateGame((prevGame) => {
// //             if (prevGame) {
// //               if (prevGame.player1_name === username) {
// //                 return { ...prevGame, player2_name: '' };
// //               } else if (prevGame.player2_name === username) {
// //                 return { ...prevGame, player1_name: '' };
// //               }
// //             }
// //             return prevGame;
// //           });
// //         }
// //       } else {
// //         // Я Готов — НЕ закрываем стол у меня
// //         console.log('Я нажал "Готов", стол у меня не закрываем');
// //       }
// //     } else {
// //       console.warn('Получены некорректные данные для resetCountdown:', data);
// //     }
// //   };

// //   // Подписываемся на событие resetCountdown
// //   socket.on('resetCountdown', handleResetCountdown);

// //   return () => {
// //     // Отписываемся от события и очищаем интервал
// //     socket.off('resetCountdown', handleResetCountdown);
// //     if (countdownInterval.current) {
// //       clearInterval(countdownInterval.current);
// //       countdownInterval.current = null;
// //     }
// //   };
// // }, [
// //   currentTableId,
// //   username,
// //   playerColor,
// //   readyStatus,
// //   navigate,
// //   setTableStates,
// //   setOpenTablesCount,
// //   updateGame
// // ]);









//   useEffect(() => {
//     if (game) {
//       const opponent = playerColor === 'white' ? game.player2_name : game.player1_name;

//       setOpponentName(opponent || 'Ожидание оппонента');
//     }
//   }, [game, playerColor]); // Зависимости: обновление при изменении game или playerColor









// useEffect(() => {
//    // Убедимся, что сокет подключен
//    if (!socket.connected) {
//     socket.connect();
//   }
// // При монтировании компонента присоединяемся к столу
// if (!hasJoinedTableRef.current && socket.connected) {
//   hasJoinedTableRef.current = true; // Устанавливаем значение в true, чтобы не вызывать повторно

//   socket.emit('reconnectToTable', { tableId, player: username });
// // socket.emit('joinTable', { tableId, player: username });
// // console.log('joinTable',{ tableId, player: username }); 

// hasJoinedTableRef.current = true; // Устанавливаем значение в true, чтобы не вызывать повторно
// //  setHasJoinedTable(true);
//   // После присоединения запрашиваем данные игры
//   socket.emit('fetchGameData', tableId);
 

//   // Обработчик получения уникального ID игрока от сервера
// socket.on('playerId', ({ id }) => {

//   // Сохраните ID игрока, если это необходимо
// });
// }
//   // Обработчик события получения данных игры
//   socket.on('gameDataResponse', (gameData) => {
//     if (!gameData) return <div>Загрузка данных игры...</div>;
//     if (gameData && gameData.table_id === parseInt(tableId, 10)) {
//       updateGame(gameData);
//       // Дополнительная логика по обновлению состояния
//     }
//   });



//   socket.on('gameUpdated', (updatedGame1) => {
   
    
//     if (updatedGame1.table_id === parseInt(tableId, 10)) {
//       updateGame(updatedGame1);
//       setMoves(updatedGame1.moves || []);
//       setCurrentTurn(updatedGame1.current_turn); // Обновление currentTurn
//       if (game && game.board_state) {
      
//       } else {
      
//       }
     
//          // Определяем цвет игрока и обновляем testik только для текущего игрока
//   if (playerColor === 'white') {
//     // Если игрок белый, обновляем его состояние testik
//     setTestik(updatedGame1.testik_player1);
//   } else if (playerColor === 'black') {
//     // Если игрок черный, обновляем его состояние testik
//    setTestik(updatedGame1.testik_player2);
//   }

     
    
      
//       if (updatedGame1.player1_name === username) {
//         setPlayerColor('white');
//       } else if (updatedGame1.player2_name === username) {
//         setPlayerColor('black');
//       }
     
//     }
//   });

//   socket.on('startGameMessage', ({ tableId, player1Roll, player2Roll, currentTurn, boardState }) => {
//     // setShowReadyButton(false); 
//     setShowModal(true);
//     setTimeout(() => setShowModal(false), 2000);
//     setTimer(null);
//     updateGame((prevGame) => ({
//       ...prevGame,
//       player1Roll,
//       player2Roll,
//       currentTurn,
//       boardState,
//     }));
  
//   });

//   // socket.on('playerReadyStatus', ({ tableId: id, player1Ready, player2Ready }) => {
  
//   //   if (id === parseInt(tableId, 10)) {
//   //     updateReadyStatus('player1', Boolean(player1Ready));
//   //     updateReadyStatus('player2', Boolean(player2Ready));
     
//   //   }
//   // });
//   // socket.on('playerReadyStatus', ({ tableId: id, player1Ready, player2Ready }) => {
//   //   console.log(`Получено событие playerReadyStatus для стола ${id}`);
//   //   console.log(`Игрок 1 готов: ${player1Ready}, Игрок 2 готов: ${player2Ready}`);
    
//   //   if (id === parseInt(tableId, 10)) {
//   //     console.log('Обновляем статус готовности для игроков на клиенте');
//   //     updateReadyStatus('player1', Boolean(player1Ready));
//   //     updateReadyStatus('player2', Boolean(player2Ready));
  
//   //     // Если оба игрока готовы, активируем кнопку первого броска
//   //     if (player1Ready && player2Ready) {
//   //       console.log('Оба игрока готовы, устанавливаем rollEnabled в true');
//   //       setRollEnabled(true);
//   //     }
//   //   }
//   // });
//   socket.on('playerReadyStatus', ({ tableId: id, player1Ready, player2Ready }) => {
//     console.log(`Получено событие playerReadyStatus для стола ${id}`);
//     console.log(`Игрок 1 готов: ${player1Ready}, Игрок 2 готов: ${player2Ready}`);
  
//     if (id === parseInt(tableId, 10)) {
//       console.log('Обновляем статус готовности для игроков на клиенте');
//       updateReadyStatus('player1', Boolean(player1Ready));
//       updateReadyStatus('player2', Boolean(player2Ready));
//       console.log('ываываыа',player1Ready && player2Ready);
//       // Проверяем, если оба игрока готовы
//       if (player1Ready && player2Ready) {
//         console.log('Оба игрока готовы, устанавливаем rollEnabled в true');
//         setRollEnabled(true);
  
//         // Скрываем кнопку "Готов"
//         // setShowReadyButton(false)
//       } else {
//         // Если не оба игрока готовы, кнопка "Готов" остаётся
//         const currentPlayerReady =
//           playerColor === 'white' ? player1Ready : player2Ready;
//           // setShowReadyButton(!currentPlayerReady);
//           console.log('fghfgh',currentPlayerReady);
//       }
//     }
//   });
  
 

// socket.on('diceRolled', ({ tableId, currentPlayer, diceValues, numberMove,shetchik,flagFirst }) => {
// console.log('отпра',{ tableId, currentPlayer, diceValues, numberMove });
// setShetchik((prev) => prev + shetchik);
// if (flagFirst !== undefined) {
//   setFlagFirst(flagFirst);
//   localStorage.setItem('flagFirst', flagFirst); // Сохраняем для восстановления после перезагрузки
 
// }
  
// // Проверяем, выпали ли дубли (куш)
// let movesCount;
// let rolledDiceValues;

// if (diceValues[0] === diceValues[1]) {
//  console.log('кубики',);
 
//   // Выпали дубли (куш)
//   movesCount = 4; // Устанавливаем 4 хода
//   rolledDiceValues = [diceValues[0], diceValues[0], diceValues[0], diceValues[0]]; // Четыре одинаковых значения
// } else {
//   // Обычный бросок
//   movesCount = 2; // Устанавливаем 2 хода
//   rolledDiceValues = diceValues; // Два значения кубиков
// }

// // Устанавливаем количество ходов для текущего игрока
//  setNumberMove(numberMove || movesCount); // Используем значение `numberMove` от сервера, если оно есть
// setRolledDice(rolledDiceValues); // Устанавливаем значения кубиков
// setHasRolledDice(true)
// // Обновляем текущий ход в состоянии игры
// updateGame((prevGame) => ({
//   ...prevGame,
//   current_turn: currentPlayer
// }));

// });



//   socket.on('firstRollStatus', ({ tableId, player1Roll, player2Roll }) => {
  
//     setFirstRolls({ player1Roll, player2Roll });
//     if (player1Roll !== null && player2Roll !== null) {
//       if (player1Roll > player2Roll) {
//         setCurrentTurn('player1');
//          setRollEnabled(false);
//          setFirstMoveComplete(true);
      
//       } else if (player1Roll < player2Roll) {
//         setCurrentTurn('player2');
//          setRollEnabled(false);
//         setFirstMoveComplete(true);
      
//       } else {
//         setFirstRolls({ player1Roll: player1Roll, player2Roll: player2Roll });
//           setRollEnabled(true);
      
//       }
//     }

//   });

//   return () => {
//     // socket.disconnect();
//     socket.off('gameUpdated');
//     socket.off('playerId');
//     socket.off('startGameMessage');
//     socket.off('playerReadyStatus');
//     // socket.off('startCountdown');
//     socket.off('diceRolled');
//     socket.off('firstRollStatus');
//   };
// }, [tableId, username,hasRolledDice]);

// // useEffect(() => {
// //   if (!hasJoinedTable) {
// //     socket.emit('joinTable', { tableId, player: username });
// //     setHasJoinedTable(true);
// //   }
// // }, [hasJoinedTable, tableId, username]);





//   useEffect(() => {
//     if (timer !== null && timer > 0) {
//       const timerId = setInterval(() => {
//         setTimer((prevTimer) => prevTimer - 1);
//       }, 1000);
//       return () => clearInterval(timerId);
//     } else if (timer === 0) {
//       socket.emit('leaveTable', { tableId, player: username });
//       navigate('/');
//     }
//   }, [timer, tableId, navigate, username]);

//   const sendMove = (move) => {
//     console.log('Отправка события makeMove', { tableId, move, currentPlayer: game.current_turn });
//     if (rolledDice.length === 0) {
//       console.error('Сначала бросьте кубики!');
//       return;
//     }
//     console.log('Отправка события makeMove', { tableId, move, currentPlayer: game.current_turn });
//     socket.emit('makeMove', { tableId, move, currentPlayer: game.current_turn });
//   };

//   // const handleReadyClick = () => {
   
//   //   socket.emit('playerReady', { tableId, player: username });
//   //   updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
//   //   setShowReadyButton(false);
//   // };

// //   const handleReadyClick = () => {
// //     socket.emit('playerReady', { tableId, player: username });
// //     updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
// //     setShowReadyButton(false);
// //   };
// // console.log('готов',updateReadyStatus);
// const handleReadyClick = () => {
//   socket.emit('playerReady', { tableId, player: username });
//   // updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
//   // setShowReadyButton(false);
 
//   // Проверка, если оба игрока готовы, включаем возможность для броска кубиков
//   // if (readyStatus.player1 && readyStatus.player2) {
//   //   setRollEnabled(true);
//   //   updateFirstRollEnabledOnServer(true); // Обновляем состояние на сервере, что бросок кубиков включен
//   // }
// };

  
//   // const handleFirstRollClick = () => {
   
//   //   socket.emit('firstRollDice', { tableId, player: username });
//   //   setFlagTestik(true)
//   //    setRollEnabled(false);
     
//   // };
//   const handleFirstRollClick = () => {
//     socket.emit('firstRollDice', { tableId, player: username });
//     setFlagTestik(true);
//     setRollEnabled(false);
//     updateFirstRollEnabledOnServer(false); // Обновляем состояние на сервере
//   };
  

//   // const handleLeaveClick = () => {
//   //   console.log('Перед отправкой leaveTable:', tableId, playerColor);
//   //   setOpenTablesCount((prevCount) => Math.max(prevCount - 1, 0));
//   //   socket.emit('leaveTable', { tableId, player: username });
//   //   // navigate('/');
//   //   navigate('/', { state: { fromGame: true } }); // Передаём состояние
//   //   // Удаляем запись из tableStates
//   //   setTableStates((prev) => {
//   //     const updated = { ...prev };
//   //     delete updated[tableId]; // Удаляем ключ текущего стола
//   //     localStorage.setItem('tableStates', JSON.stringify(updated)); // Сохраняем обновленное состояние
//   //     console.log('Обновленное tableStates после удаления стола:', updated);
//   //     return updated;
//   // });

//   //   // updateTableState(tableId, { isClosed: true, isMinimized: false });
  
//   //   setTimeout(() => {
//   //     console.log('Состояние tableStates после обновления:', tableStates);
//   //   }, 0); // Используем `setTimeout`, чтобы дождаться обновления состояния
  
//   //   // Явно сбрасываем каждое состояние
//   //   setPlayerColor(null);
//   //   setCurrentTurn(null);
//   //   setHasRolledDice(false);
//   //   setRolledDice([]);
//   //   // setShowReadyButton(false);
//   //   setCountdown(0);
//   //   setOpponentName('Ожидание второго игрока');
//   //   setFirstRolls({ player1Roll: null, player2Roll: null });
//   //   setRollEnabled(false);
//   //   setFirstMoveComplete(false);
//   //   setTestik(false);
//   //   setFlagFirst(0);
//   //   setShetchik(0);
  
//   //   // Очищаем localStorage
//   //   localStorage.removeItem('flagFirst');
//   //   localStorage.removeItem('shetchik');
//   // };
  


//   const handleLeaveClick = () => {
//     console.log('Перед отправкой leaveTable:', tableId, playerColor);
  
//     // Отправляем событие для уменьшения `openTableCount`
//     socket.emit('decrementOpenTableCount', { tableId, username });

//     setOpenTablesCount((prevCount) => Math.max(prevCount - 1, 0));
//     socket.emit('leaveTable', { tableId, player: username });
//     navigate('/', { state: { fromGame: true } });






//     setOpenTablesCount((prevCount) => Math.max(prevCount - 1, 0));
//     socket.emit('leaveTable', { tableId, player: username });
//     navigate('/', { state: { fromGame: true } }); // Передаём состояние
  
//     // Удаляем запись из tableStates и синхронизируем с localStorage
//     setTableStates((prev) => {
//       const updated = { ...prev };
//       delete updated[tableId]; // Удаляем ключ текущего стола
//       console.log('Обновленное tableStates после удаления стола:', updated);
  
//       // Сохраняем в localStorage только после обновления состояния
//       localStorage.setItem('tableStates', JSON.stringify(updated));
  
//       // Проверяем текущее состояние `tableStates` в localStorage
//       console.log('Состояние tableStates в localStorage после удаления:', localStorage.getItem('tableStates'));
  
//       return updated;
//     });
  
//     // Явно сбрасываем каждое состояние
//     setPlayerColor(null);
//     setCurrentTurn(null);
//     setHasRolledDice(false);
//     setRolledDice([]);
//     setCountdown(0);
//     setOpponentName('Ожидание второго игрока');
//     setFirstRolls({ player1Roll: null, player2Roll: null });
//     setRollEnabled(false);
//     setFirstMoveComplete(false);
//     setTestik(false);
//     setFlagFirst(0);
//     setShetchik(0);
  
//     // Очищаем другие данные в localStorage
//     localStorage.removeItem('flagFirst');
//     localStorage.removeItem('shetchik');
//   };
  
  
//   // Используем useEffect, чтобы синхронизировать обновление с localStorage
//   useEffect(() => {
//     localStorage.setItem('tableStates', JSON.stringify(tableStates));
//   }, [tableStates]);








//   // const handleLeaveClick = () => {
//   //   socket.emit('leaveTable', { tableId, player: username });
//   //   navigate('/');
//   // };

//   // Обработчик события для удаления игрока, который не нажал на "Готов"
// // socket.on('playerLeft', ({ tableId, player }) => {
// //   if ((player === 'player1' && playerColor === 'white') || (player === 'player2' && playerColor === 'black')) {
// //       navigate('/'); // Перенаправляем только если текущий игрок не нажал "Готов"
// //   }
// // });


// useEffect(() => {
//   console.log('hasRolledDice после обновления:', hasRolledDice);
// }, [hasRolledDice]);

// // Обработчик playerLeft для обновления стола и отображения кнопки "Присоединиться"
// socket.on('playerLeft', ({ tableId, player }) => {
//   // Очищаем данные об оппоненте для оставшегося игрока
//   console.log('ergeg');
  
//   const iAmPlayer = (playerColor === 'white') ? 'player1' : 'player2';
//    if (player === iAmPlayer) {
//     // Стол закрываем только у того игрока, который действительно вышел
//     console.log('Это мой playerLeft, ухожу в лобби');
//     navigate('/');
//      localStorage.removeItem('tableStates');
//      setTableStates({});
//      setOpponentName('Ожидание второго игрока');
//    } else {
//      console.log('Событие playerLeft пришло про другого игрока, у меня стол не закрываем');
//    }
// });


//   const handleRollDiceClick = () => {
//     setShetchik(prevShetchik => prevShetchik + 1)
    
//     setFlagTestik(true)
//     setHasRolledDice(true)
//     setFirstRollComplete(true)
//     // setTestik(true)
//     // Увеличиваем flagFirst и сохраняем его в localStorage
//     // setFlagFirst((prevFlagFirst) => {
//     //   const newFlagFirst = prevFlagFirst + 1;
//     //   localStorage.setItem("flagFirst", newFlagFirst);
   
    
//     socket.emit('rollDice', { tableId: game.table_id, currentPlayer: currentTurn,testik: true,shetchik});
//   // })
//   };

// // До о1
//   // const handleConfirmMove = () => {
//   //   setNumberMove(2); // Or set to 0 if appropriate
    
    
//   //   socket.emit('confirmMove', { tableId: game.table_id, player: currentTurn, boardState: JSON.stringify(game.board_state) });
//   //   const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
   
    
//   //   // setTestik(false); // Скрываем кнопку "Бросить кубики" для текущего игрока
//   //   setCurrentTurn(nextTurn); // Устанавливаем следующий ход
//   //   setRolledDice([]); // Обнуляем значения кубиков для следующего игрока
    
//   // };
//   const handleConfirmMove = () => {
//     setNumberMove(2); // Or set to 0 if appropriate

//     const capturedCheckersData = {
//       white: capturedCheckers.white || 0,
//       black: capturedCheckers.black || 0,
//     };

//     const offBoardData = {
//       white: whiteOffBoard || [],
//       black: blackOffBoard || [],
//     };
   
//     socket.emit('confirmMove', { tableId: game.table_id, player: currentTurn, boardState: JSON.stringify(game.board_state),capturedCheckers: capturedCheckersData,whiteOffBoard: offBoardData.white,blackOffBoard: offBoardData.black });
//     const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
    
//     setCurrentTurn(nextTurn); // Устанавливаем следующий ход
//     setRolledDice([]); // Обнуляем значения кубиков для следующего игрока
    
//     // setHasRolledDice(false); // Сбрасываем состояние броска кубиков для следующего хода
//   };
  
//   // useEffect(() => {
//   //   if (currentTurn && isTestikLoaded) { // Проверяем, что данные загружены и есть текущий ход
//   //     const isMyTurn = currentTurn === (playerColor === 'white' ? 'player1' : 'player2');
  
//   //     // Проверка перед установкой `testik`
//   //     console.log("Проверка перед изменением testik:", {
//   //       testik,
//   //       isMyTurn,
//   //       hasRolledDice,
//   //       isTestikLoaded
//   //     });
  
//   //     // Устанавливаем `testik` на true, если это наш ход и кубики еще не брошены, и `testik` изначально false
//   //     if (testik === false && isMyTurn && !hasRolledDice) {
//   //       console.log("Устанавливаем testik на true, так как это наш ход и кубики еще не брошены");
//   //       setTestik(true);
//   //     }
//   //   }
//   // }, [currentTurn, playerColor, hasRolledDice, isTestikLoaded]);
  
//   // Логируем значение `testik` при каждом изменении
//   // useEffect(() => {
//   //   console.log("Текущее значение testik после обновления:", testik);
//   // }, [testik]);
  
  
  

//   // useEffect(() => {
//   //   // Если страница обновлена и кубики не были брошены, то показываем кнопку броска
//   //   if (!hasRolledDice) {
    
      
//   //      setHasRolledDice(false) 
//   //   }
//   // }, [hasRolledDice]);

//   useEffect(() => {
  

//     const playerKey = playerColor === 'white' ? 'player1' : 'player2';
//     // console.log(`Подготовка к отправке testik на сервер через сокет:`, {
//     //     tableId,
//     //     testik,
//     //     player: playerKey
//     // });

//     // Отправка через сокет с логом для проверки на клиенте
//     socket.emit('updateTestik', {
//         tableId,
//         testik,
//         player: playerKey
//     }, (response) => {
//         // console.log('Ответ сервера на updateTestik:', response);
//     });
// }, [testik, tableId, playerColor]);







// useEffect(() => {
//   socket.on('testikUpdated', (data) => {
//       const { player, testik: newTestik } = data;
//       if (player === (playerColor === 'white' ? 'player1' : 'player2')) {
//           setTestik(newTestik);
//           // console.log('Значение testik обновлено из сокета:', newTestik);
//       }
//   });

//   return () => {
//       socket.off('testikUpdated');
//   };
// }, [playerColor]);





// const updateFirstRollEnabledOnServer = (firstRollEnabled) => {
//   const playerKey = playerColor === 'white' ? 'player1' : 'player2';
//   socket.emit('updateFirstRollEnabled', {
//     tableId,
//     player: playerKey,
//     firstRollEnabled
//   });
// };

 


// useEffect(() => {
//   // Эмитируем событие 'joinTable' при монтировании компонента Game
//   socket.emit('reconnectToTable', { tableId, player: username });
//   console.log(`Игрок ${username} присоединился к столу ${tableId} после обновления страницы`);

//   // Обработка события 'playerJoinedTable', если необходимо
//   socket.on('playerJoinedTable', ({ tableId: joinedTableId, player }) => {
//     if (joinedTableId === tableId && player === username) {
//       console.log(`Игрок ${username} успешно присоединился к столу ${joinedTableId}`);
//     }
//   });

//   return () => {
//     socket.off('playerJoinedTable');
//   };
// }, [tableId, username]);






//   useEffect(() => {
    
//     if (currentTurn && flagTestik==true ) {
//       console.log('345345345543',flagTestik);
      
//       // setRollEnabled(false)
       
//       {
//         const isMyTurn = currentTurn === (playerColor === 'white' ? 'player1' : 'player2');
//         const newTestikValue = isMyTurn && hasRolledDice;
      
        
//         // setRollEnabled(newTestikValue);
//         console.log('2222222222222',rollEnabled);
//       } 
      
      
//     }
   
//   }, [currentTurn, playerColor, hasRolledDice]);
  

  

// if (!game) {
//   return <div>Загрузка...</div>;
// }

  
//   return (
//     <div className='bbb'>
//       {countdown}
//       {/* <p>{testik.toString()}</p> */}
//       {/* <h1>Игра {game.id}</h1>
//       <div>Игрок 1: {game.player1_name}</div>
//       <div>Игрок 2: {game.player2_name || 'Ожидание игрока 2'}</div> */}
//       {/* <div>Ставка: {game?.bet}</div> */}
//       {/* <div>Очки матча: {game?.match_points}</div>
//       <div>Время матча: {game?.match_time}</div> */}
//       {/* { <p>кнопка кубики {testik.toString()}</p> } */}
//       {/* { <p>Бросил ли кубики 888888888888  {hasRolledDice.toString()}</p> } */}
//       {/* { <p>Сейчас ход {currentTurn}</p> } */}
//     {/* { <p>Testik 5555555555555 {testik.toString()}</p> } */}
     
//       {/* { <p>Первый бросок 2 {firstMoveComplete.toString()}</p> } */}
    
     
   
     
//           {/* {rollEnabled && !firstMoveComplete && (
//             <button onClick={handleFirstRollClick}>Первый бросок</button>
//           )} */}
//            {/* {rollEnabled &&(
//             <button onClick={handleFirstRollClick}>Первый бросок</button>
//           )} */}
//           {/* {rollEnabled && readyStatus.player1 && readyStatus.player2 && !firstRollComplete && (
//   <button onClick={handleFirstRollClick}>Первый бросок</button>
// )} */}

//           {/* {rollEnabled && readyStatus.player1 && readyStatus.player2 && (
//   <button onClick={handleFirstRollClick}>Первый бросок</button>
// )} */}

//       {/* <ShortBackgammonBoard
//         moves={moves}
//         sendMove={sendMove}
//         playerColor={playerColor}
//         // initialBoardState={game?.board_state}
//         initialBoardState={game?.board_state || []} // Устанавливаем пустой массив, если данные отсутствуют
//         currentTurn={currentTurn}
//         diceRolls={rolledDice}
//         handleConfirmMove={handleConfirmMove} // Передаем handleConfirmMove в ShortBackgammonBoard
//         handleRollDiceClick={handleRollDiceClick} 
//         handleFirstRollClick = {handleFirstRollClick}
//         hasRolledDice = {hasRolledDice}
//         setHasRolledDice = {setHasRolledDice} 
       
//          /> */}

// <ShortBackgammonBoard
//   moves={moves}
//   sendMove={sendMove}
//   playerColor={playerColor}
//   initialBoardState={game?.board_state || []}
//   currentTurn={currentTurn}
//   diceRolls={rolledDice}
//   handleConfirmMove={handleConfirmMove}
//   handleRollDiceClick={handleRollDiceClick}
//   handleFirstRollClick={handleFirstRollClick}
//   hasRolledDice={hasRolledDice}
//   setHasRolledDice={setHasRolledDice}
//   firstMoveComplete={firstMoveComplete}
//   firstRollComplete={firstRollComplete}
//   isFirstMoveDone={isFirstMoveDone}
//   firstRolls={firstRolls}
//   numberMove={numberMove}
//   showReadyButton = {showReadyButton}
//   handleReadyClick = {handleReadyClick}
//   readyStatus = {readyStatus}
//   countdown = {countdown}
//   opponentName = {opponentName}

//   shetchik = {shetchik}
//   setShetchik = {setShetchik}

//   onCollapse={handleCollapse} token={token}

  
//   // ... other necessary props
// />
// {/* <BoardDisplay 
//   hasRolledDice={hasRolledDice}
//   currentTurn={currentTurn}
//   playerColor={playerColor}
//   handleRollDiceClick={handleRollDiceClick}
  
// /> */}
//  {/* {game?.player1_name && game?.player2_name ? (
//         <div>
//           {showReadyButton && (
//             <div>
//               <button onClick={handleReadyClick} disabled={readyStatus.player1 && readyStatus.player2}>
//                 {readyStatus.player1 && readyStatus.player2 ? 'Ожидание начала игры...' : 'Готов'}
//               </button>
//               <div>Оставшееся время: {countdown}</div>
//             </div>
//           )}

//         </div>
//       ) : ( 
//         <div>Ожидание оппонента...</div>
//       )} */}
//       {game?.player1_name && game?.player2_name && (
//         <>
//           <div>Текущий игрок: {currentTurn ? game[currentTurn + '_name'] : 'Ожидание броска'}</div>
//           <div>Оппонент: {opponentName}</div>
          
//           {/* {!hasRolledDice && currentTurn === (playerColor === 'white' ? 'player1' : 'player2') && (
//             <button className="roll-dice-button" onClick={handleRollDiceClick}>Бросить кубики</button>
//           )} */}
//            {/* <button onClick={handleRollDiceClick}>Бросить кубики</button> */}
//           {/* {rollEnabled && currentTurn === (playerColor === 'white' ? 'player1' : 'player2') && (
//   <button onClick={handleRollDiceClick}>Бросить кубики</button>
// )} */}
// {/* <button onClick={handleRollDiceClick}>Бросить кубики</button> */}
        
//         </>
//       )}
//   {/* {rolledDice.length > 0 && (
//             <div>
//               <p>Значения кубиков: {rolledDice[0]}, {rolledDice[1]}</p>
//             </div>
//           )} */}
//       {showModal && <Modal message="Желаем удачи!" />}
//       <button onClick={handleLeaveClick} style={{ position: 'absolute', right: '50px' }}>Покинуть стол</button> 
//     </div>




//   );
// };

// export default Game;


import React, { useEffect, useState, useRef  } from 'react'; 
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import { useParams, useNavigate } from 'react-router-dom'; 
import socket from './socket';
import './Board.css';
import ShortBackgammonBoard from './ShortBackgammonBoard';
import TournamentMatch from './TournamentMatch';
// import Modal from './Modal';
import { useGame } from './context/GameContext';
import axios from 'axios';
import './Game.css';
import './Board.css';


const Game = ({ token,handleFirstRollStatus }) => {
  const { t: translate } = useTranslation();
  const { tableId } = useParams();
  const navigate = useNavigate();
  const {
    game,setGame, updateGame,diceRolls, setDiceRolls, rollEnabled, setRollEnabled, readyStatus, updateReadyStatus,
    firstRolls, setFirstRolls, currentTurn, setCurrentTurn, rollDiceEnabled, setRollDiceEnabled, confirmMoveEnabled, setConfirmMoveEnabled,
    testik,flagFirst, setFlagFirst, setTestik,dataLoaded,usedRolls, setUsedRolls,enteredCheckerData, setEnteredCheckerData,whiteOffBoard, setWhiteOffBoard,blackOffBoard, setBlackOffBoard,capturedCheckers, setCapturedCheckers,moveHistory, setMoveHistory, setDataLoaded,isFirstMoveDone, setIsFirstMoveDone,firstRollComplete,setFirstRollComplete,numberMove, setNumberMove, playerColor, setPlayerColor, turnCompleted,firstMoveComplete, setFirstMoveComplete, setTurnCompleted,rolledDice, setRolledDice, currentTableId, setCurrentTableId,tableStates, setTableStates
  } = useGame();

  
  const [moves, setMoves] = useState([]);
  const [timer, setTimer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [showReadyButton, setShowReadyButton] = useState(false);
  const [opponentName, setOpponentName] = useState(translate('game.common.waitingSecondPlayer'));
   // useRef для хранения идентификатора интервала
   const countdownInterval = useRef(null);
   const [isTestikLoaded, setIsTestikLoaded] = useState(false); // Новый флаг
   const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
   const [flagTestik, setFlagTestik] = useState(false);
   const [test, setTest] = useState(false);
   const [shetchik, setShetchik] = useState(() => {
    const savedValue = localStorage.getItem('shetchik');
    return savedValue ? parseInt(savedValue, 10) : 0;
  });
  const [hasRolledDice, setHasRolledDice] = useState(false)
  const [flagButtonFirst, setFlagButtonFirst] = useState(0)
 
 





  // const [hasRolledDice, setHasRolledDice] = useState(() => {
  //   const savedValueHasRolledDice = localStorage.getItem('hasRolledDice');
  //   return savedValueHasRolledDice ? savedValueHasRolledDice === 'false' : true;
  // });
  

  //  const [hasJoinedTable, setHasJoinedTable] = useState(false);
  const username = localStorage.getItem('username');
 
  const didMountRef = useRef(false);
  // Используем useRef вместо useState для отслеживания отправки joinTable
  const hasJoinedTableRef = useRef(false);

  const requestCountRef = useRef(0);

//Основ до о1
// useEffect(() => {
//   socket.on("gameDataResponse", (gameData) => {
//     if (!gameData) {
//       console.error("Данные игры не найдены");
//       return;
//     }

    
//     updateGame(gameData);

//     // Устанавливаем текущий ход
//     setCurrentTurn(gameData.current_turn);
//     setNumberMove(gameData.numberMovePlayer1)
//     console.log('44444',numberMove);
    
//     // Определяем цвет игрока
//     let playerColorLocal = null;
//     if (gameData.player1_name === username) {
//       playerColorLocal = "white";
//     } else if (gameData.player2_name === username) {
//       playerColorLocal = "black";
//     }
//     setPlayerColor(playerColorLocal);

//     // Проверка, бросил ли игрок кубики
//     let hasRolled = false;
//     let lastRoll = [];
//     const playerRolls =
//       playerColorLocal === "white" ? gameData.player1_rolls : gameData.player2_rolls;

//     if (playerRolls) {
//       const rolls = JSON.parse(playerRolls);
//       lastRoll = rolls.length ? rolls[rolls.length - 1] : [];
//       hasRolled = rolls.length > 0 && Array.isArray(rolls[rolls.length - 1]);
//     }

//     setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
//     setHasRolledDice(hasRolled);

//     // Устанавливаем количество ходов
//     const movesCount = lastRoll[0] === lastRoll[1] ? 4 : 2;
//     setNumberMove(lastRoll.length > 0 ? movesCount : 2);

//     // Восстанавливаем значение `testik` для текущего игрока
//     if (!gameData.firstMoveComplete) {
//       // Если первый ход еще не завершен  !!!!!!!!!!!!! Если раскоментить то после первого хода скрывается кнопка но после обновления она пропадает
//       // setTestik(true); // Скрыть кнопку "Бросить кубики"
//     } else {
//       const isMyTurn = gameData.current_turn === (playerColorLocal === 'white' ? 'player1' : 'player2');
//       // Показать кнопку, если это мой ход и кубики еще не были брошены
//       setTestik(!(isMyTurn && !hasRolled));
//     }

  
//   });

//   return () => {
//     socket.off("gameDataResponse");
//   };
// }, [tableId, username,numberMove]);


// useEffect(() => {
//   socket.on('gameAlreadyExists', ({ tableId }) => {
//     alert(`Игра для стола ${tableId} уже существует. Пожалуйста, присоединитесь к существующей игре.`);
//     navigate('/'); // При необходимости перенаправьте пользователя на другую страницу
//   });

//   return () => {
//     socket.off('gameAlreadyExists');
//   };
// }, []);





// useEffect(() => {
//   if (!socket.connected) {
//     socket.connect();
//   }

//   if (!hasJoinedTableRef.current && socket.connected) {
//     hasJoinedTableRef.current = true;
//     console.log('Отправка запроса joinTable');
//     console.log('Флаг hasJoinedTableRef после отправки:', hasJoinedTableRef.current);

//     socket.emit('joinTable', { tableId, player: username });
//   }
// }, [tableId, username]);



const handleCollapse = () => {
  

  // Обновляем состояние: стол свернут
  updateTableState(tableId, { isMinimized: true, isClosed: false });

  // Переход в лобби
  navigate('/');
};

// до обычного бота
// const updateTableState = (tableId, updates) => {
//   setTableStates((prev) => {
//     const currentState = prev[tableId] || {};
//     const newState = { ...currentState, ...updates };

//     if (JSON.stringify(currentState) === JSON.stringify(newState)) {
//       console.log(`Состояние для стола ${tableId} не изменилось, пропускаем обновление.`);
//       return prev;
//     }

//     console.log(`Обновляем состояние для стола ${tableId}:`, newState);
//     return {
//       ...prev,
//       [tableId]: newState,
//     };
//   });
// };
const updateTableState = (tableId, changes) => {


  let updatedTableStates = { ...tableStates };

  if (changes?.isClosed) {
    // Если стол закрыт, удаляем его из состояния
    delete updatedTableStates[tableId];
  } else {
    // Вносим изменения в состояние стола
    updatedTableStates = {
      ...updatedTableStates,
      [tableId]: { ...tableStates[tableId], ...changes },
    };
  }

  setTableStates(updatedTableStates);
  localStorage.setItem('tableStates', JSON.stringify(updatedTableStates));
};




// useEffect(() => {
//   setCurrentTableId(tableId); // Сохраняем ID текущего стола при заходе
//   console.log("Выходим со стола:", tableId);
//   return () => setCurrentTableId(tableId); // Очищаем ID стола при выходе
  
// }, [tableId, setCurrentTableId]);


// useEffect(() => {
//   console.log("Зашли за стол:", tableId);
  
//   // Сохраняем ID текущего стола при входе
//   setCurrentTableId(tableId);

//   return () => {
//     // Проверяем, закрыт стол или свернут
//     if (window.location.pathname.includes('/game')) {
//       setCurrentTableId(tableId); // Если свернули, сохраняем ID
//     } else {
//       setCurrentTableId(tableId); // Если вышли, очищаем ID
//     }
//   };
// }, [tableId, setCurrentTableId]);



useEffect(() => {


  updateTableState(tableId, { isClosed: false, isMinimized: false });

  return () => {
    const fromGame = window.history.state?.usr?.fromGame || false;
    if (fromGame) {
   
      updateTableState(tableId, { isClosed: true, isMinimized: false });
    
     } 
    //  else {
    //   console.log("Свернули стол:", tableId);
    //   updateTableState(tableId, { isMinimized: true, isClosed: false });
    // }
  };
}, [tableId]);




// useEffect(() => {
//   console.log("Зашли за стол:", tableId);

//   updateTableState(tableId, { isClosed: false, isMinimized: false });

//   return () => {
//     const fromGame = window.history.state?.usr?.fromGame || false;

//     // Если стол закрыт через таймер, не устанавливаем isMinimized
//     const isTableClosedByTimer = tableStates[tableId]?.isClosed;

//     if (fromGame) {
//       console.log("Закрыли стол:", tableId);
//       updateTableState(tableId, { isClosed: true, isMinimized: false });
//     } else if (!isTableClosedByTimer) {
//       console.log("Свернули стол:", tableId);
//       updateTableState(tableId, { isMinimized: true, isClosed: false });
//     }
//   };
// }, [tableId]);








useEffect(() => {
  if(shetchik <=2){ 
    setDataLoaded(true)
  }
  else {
    setDataLoaded(false)
  }
}, [shetchik,dataLoaded]);

useEffect(() => {
  localStorage.setItem('shetchik', shetchik);
}, [shetchik]);




 

// useEffect(() => {
//   console.log('Сохранение hasRolledDice в localStorage:', hasRolledDice);
//   localStorage.setItem('hasRolledDice', hasRolledDice.toString());
// }, [hasRolledDice]);




useEffect(() => {
  const handleConnect = () => {
   





    // Чтобы не отправлять event многократно, проверяем ref
    if (!hasJoinedTableRef.current && socket.connected) {
      hasJoinedTableRef.current = true;

      // Именно здесь понимаем, что стол "открыт"
      // => increment openTableCount на сервере
      socket.emit('incrementOpenTableCount', { tableId, username });



     socket.emit('joinTable', { tableId, player: username });
    }
   
  };

  // if (socket.connected) {
  //   console.log('Сокет уже подключен');
  //   socket.emit('joinTable', { tableId, player: username });
  //   console.log(`Отправлено событие joinTable для пользователя ${username} и стола ${tableId}`);
  // } else {
  //   console.log('Сокет не подключен, устанавливаем обработчик connect и вызываем socket.connect()');
  //   socket.on('connect', handleConnect);
  //   socket.connect();
  // }

  return () => {
    socket.off('connect', handleConnect);
  };
}, [tableId, username]);





  


  // useEffect (()=>{
  //   console.log('player2FirstRollEnabled1111',  rollEnabled);
    
  //   },[ rollEnabled])







// Добавляю автомат обновление запрос на сервер если убитые шашки, чтобы не зависало

















// До о1
useEffect(() => {
  socket.on("gameDataResponse", (gameData) => {
    
    if (gameData.table_id !== parseInt(tableId,10)) {
     
      return;
    }
    setMoveHistory([]); // Очищаем историю ходов
    
    setDataLoaded(true);
    if (!gameData) {
      console.error("Данные игры не найдены");
      return;
    }
  setFirstMoveComplete(gameData.firstMoveComplete)
  setFirstRollComplete(gameData.firstRollComplete)
    let playerColorLocal = null;
if (gameData.player1_name === username) {
  playerColorLocal = "white";
} else if (gameData.player2_name === username) {
  playerColorLocal = "black";
}


setPlayerColor(playerColorLocal);
// Обновляем состояния броска кубиков
   // Восстанавливаем убитые шашки
   const capturedCheckers = gameData.captured_checkers || { white: 0, black: 0 };
   setCapturedCheckers(capturedCheckers);
   

   // Восстанавливаем выведенные шашки
   const whiteOffBoard = gameData.white_off_board || [];
   const blackOffBoard = gameData.black_off_board || [];
   setWhiteOffBoard([...whiteOffBoard]);
   setBlackOffBoard([...blackOffBoard]);
   
  
   





  // Логирование данных перед установкой состояний
  
// Обновление состояния hasRolledDice на основе данных из игры
if (playerColorLocal === "white") {
  setHasRolledDice(gameData.hasRolledDicePlayer1);
} else if (playerColorLocal === "black") {
  setHasRolledDice(gameData.hasRolledDicePlayer2);
}

setCurrentTurn(gameData.current_turn);


// const hasRolledDicePlayer1 = gameData.hasRolledDicePlayer1 || false;
// const hasRolledDicePlayer2 = gameData.hasRolledDicePlayer2 || false;

// console.log('hasRolledDicePlayer1:', hasRolledDicePlayer1, 'hasRolledDicePlayer2:', hasRolledDicePlayer2);


// if (playerColorLocal === "white") {
//   if (hasRolledDicePlayer1) {
//     setHasRolledDice(true);
//     console.log('Player 1 уже бросил кубики');
//   } else {
//     setHasRolledDice(false);
//     console.log('Player 1 еще не бросил кубики');
//   }
// } else if (playerColorLocal === "black") {
//   if (hasRolledDicePlayer2) {
//     setHasRolledDice(true);
//     console.log('Player 2 уже бросил кубики');
//   } else {
//     setHasRolledDice(false);
//     console.log('Player 2 еще не бросил кубики');
//   }
// }
// console.log('Обновлено состояние hasRolledDice для текущего игрока:', hasRolledDice);








// if (playerColorLocal === 'white') {
//   setHasRolledDice(hasRolledDicePlayer1);
// } else if (playerColorLocal === 'black') {
//   setHasRolledDice(hasRolledDicePlayer2);
// }
//  console.log('Обновлено состояние hasRolledDice для текущего игрока:', hasRolledDice)
 
   // Устанавливаем готовность игроков
  
   const player1Ready = Boolean(gameData.player1_ready);
   const player2Ready = Boolean(gameData.player2_ready);
   updateReadyStatus('player1', player1Ready);
   updateReadyStatus('player2', player2Ready);
  
 
  
   
  
   

  

// Устанавливаем rollEnabled на основе firstRollComplete
 if (!gameData.firstRollComplete) { 

  // Первый бросок еще не завершен
  if (playerColorLocal === "white") {
    setRollEnabled(gameData.player1FirstRollEnabled);
    
    
  } else if (playerColorLocal === "black") {
    setRollEnabled(gameData.player2FirstRollEnabled);
   
  }
} else { 
  // Первый бросок завершен, кнопка не должна отображаться
  setRollEnabled(false); 
}
// Обновляем firstRollComplete
setFirstRollComplete(gameData.firstRollComplete);

// Обновляем состояние игры  это предложил 40 -0 но не работает, возможно надо удалить  комент
// if (gameData) {
//   setGame(gameData);
//   console.log('Состояние игры обновлено с сервера:', gameData);
// }

// до сюда удалить


    // Восстанавливаем значения кубиков
    const playerRolls1 = {
      white: gameData.player1_rolls || [],
      black: gameData.player2_rolls || [],
    };

    const myRolls = playerRolls1[playerColorLocal] || [];
    const lastRoll1 = myRolls.length > 0 ? myRolls[myRolls.length - 1] : [];
    setRolledDice(lastRoll1);
    

    // setHasRolledDice(lastRoll1.length > 0);
    // console.log('5756', rolledDice, hasRolledDice, myRolls);

// Устанавливаем текущий ход
setCurrentTurn(gameData.current_turn);



if (playerColorLocal === "white") {

  // console.log('первый ход',gameData.player1FirstRollEnabled);
  
  setNumberMove(gameData.numberMovePlayer1);

 

} else if (playerColorLocal === "black") {
  // console.log('первый ход',gameData.player2FirstRollEnabled);
  setNumberMove(gameData.numberMovePlayer2);

  
}


let hasRolled = false;
let lastRoll = [];
const playerRolls =
  playerColorLocal === "white" ? gameData.player1_rolls : gameData.player2_rolls;


if (playerRolls) {
  let rolls;
  if (typeof playerRolls === 'string' && playerRolls !== '') {
    try {
      rolls = JSON.parse(playerRolls);
    } catch (error) {
      console.error('Ошибка при парсинге playerRolls:', error);
      rolls = [];
    }
  } else if (Array.isArray(playerRolls)) {
    rolls = playerRolls;
  } else {
    rolls = [];
  }

  // Используем просто проверку на наличие элементов в массиве
  lastRoll = rolls.length ? rolls[rolls.length - 1] : [];
  hasRolled = rolls.length > 0; // Здесь мы устанавливаем булевое значение

} else {
  lastRoll = [];
  hasRolled = false;
}

setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
// Обновляем состояние firstRolls для первого броска каждого игрока

// Обновляем состояние firstRolls для первого броска каждого игрока
let player1Rolls = [];
let player2Rolls = [];



try {
  if (gameData.player1_rolls && typeof gameData.player1_rolls === 'string' && gameData.player1_rolls.trim() !== "") {
    player1Rolls = JSON.parse(gameData.player1_rolls);
   
  } else if (Array.isArray(gameData.player1_rolls)) {
    player1Rolls = gameData.player1_rolls;
  }
} catch (error) {
  console.error('Ошибка при парсинге player1_rolls:', error);
  player1Rolls = [];
}

try {
  if (gameData.player2_rolls && typeof gameData.player2_rolls === 'string' && gameData.player2_rolls.trim() !== "") {
    player2Rolls = JSON.parse(gameData.player2_rolls);
    
  } else if (Array.isArray(gameData.player2_rolls)) {
    player2Rolls = gameData.player2_rolls;
  }
} catch (error) {
  console.error('Ошибка при парсинге player2_rolls:', error);
  player2Rolls = [];
}





// Если первый ход еще не завершен, объединяем значения кубиков для первого броска
    if (!gameData.firstMoveComplete) {
      if (player1Rolls.length > 0 && player2Rolls.length > 0) {
        // Определяем победителя первого броска
        const player1FirstRoll = player1Rolls[0];
        const player2FirstRoll = player2Rolls[0];

        let firstMoveRolls;
        if (player1FirstRoll > player2FirstRoll) {
          firstMoveRolls = playerColorLocal === 'white' ? [player1FirstRoll, player2FirstRoll] : [];
        } else if (player2FirstRoll > player1FirstRoll) {
          firstMoveRolls = playerColorLocal === 'black' ? [player2FirstRoll, player1FirstRoll] : [];
        } else {
          // В случае равенства нужно переиграть, но для текущей логики просто пропускаем
          firstMoveRolls = [];
        }
       
        setRolledDice(firstMoveRolls);
       
      }
    } else {
      // Если первый ход завершен, восстанавливаем обычные броски
      let playerRolls = playerColorLocal === 'white' ? player1Rolls : player2Rolls;
      const lastRoll = playerRolls.length > 0 ? playerRolls[playerRolls.length - 1] : [];
      setRolledDice(Array.isArray(lastRoll) ? lastRoll : []);
      
    }

    // Обновляем состояние firstRolls для первого броска каждого игрока
    setFirstRolls({
      player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
      player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
    });


    // Устанавливаем текущий ход
    setCurrentTurn(gameData.current_turn);


   




setFirstRolls({
  player1Roll: player1Rolls.length > 0 ? player1Rolls[0] : null,
  player2Roll: player2Rolls.length > 0 ? player2Rolls[0] : null,
});



// setHasRolledDice(hasRolled);



   // Устанавливаем текущий ход
   setCurrentTurn(gameData.current_turn);
 
    updateGame(gameData);



 

   

   









  
    // setUsedRolls([]);
    // console.log('rolledDice после обновления:', hasRolledDice,hasRolled);

    // Устанавливаем количество ходов
    // Устанавливаем количество оставшихся ходов из базы данных
if (playerColorLocal === 'white') {
  setNumberMove(gameData.numberMovePlayer1 || 0);
 
} else if (playerColorLocal === 'black') {
  setNumberMove(gameData.numberMovePlayer2 || 0);
 
}



    // Восстанавливаем значение `testik` для текущего игрока
    if (!gameData.firstMoveComplete) {
      setRollDiceEnabled(true);
    } else {
      const isMyTurn = gameData.current_turn === (playerColorLocal === 'white' ? 'player1' : 'player2');
      // setTestik(!(isMyTurn && !hasRolledDice));
      setRollDiceEnabled(true);
    }
    
  });


  return () => {
    socket.off("gameDataResponse");
  };
}, [tableId, username]);






useEffect(() => {
  const loadGameData = () => {
    // Запрос данных игры по сокетам
    
    socket.emit('fetchGameData', tableId);

    socket.on('gameDataResponse', (gameData) => {
     
      
      // Установка начального значения testik из базы данных
      
      // if (playerColor === 'white' ) {
      //   setRollEnabled(gameData.player1FirstRollEnabled || false);
      // } else if (playerColor === 'black') {
      //   setRollEnabled(gameData.player2FirstRollEnabled || false);
      // }

      // Завершение первичной загрузки
      // setInitialLoadCompleted(true);
     

    }); 
  };

   loadGameData();

  // Чистим слушатель при размонтировании, чтобы не допустить утечек
  return () => socket.off('gameDataResponse');
}, [tableId, playerColor]);



//До обновления о1
// useEffect(() => {
//   if (initialLoadCompleted) {
//     socket.emit('updateTestik', { tableId, testik, player: playerColor === 'white' ? 'player1' : 'player2' }, (response) => {
     
//     });
//   }
// }, [testik, tableId, playerColor, initialLoadCompleted]);
useEffect(() => {
  if (initialLoadCompleted) {
    // Отправляем testik на сервер
    socket.emit('updateTestik', { 
      tableId, 
      testik, 
      player: playerColor === 'white' ? 'player1' : 'player2' 
    }, (response) => {
      // Обработка ответа, если необходимо
    });

    // Отправляем rollEnabled на сервер
     updateFirstRollEnabledOnServer(rollEnabled);
  }
}, [testik, tableId, playerColor, initialLoadCompleted]);




// Добавляем проверку и лог для каждого обновления testik
useEffect(() => {
  

  const playerKey = playerColor === "white" ? "player1" : "player2";
  // console.log(`Подготовка к отправке testik на сервер через сокет:`, {
  //   tableId,
  //   testik,
  //   player: playerKey,
  // });

  // Отправка через сокет с логом для проверки на клиенте
  socket.emit(
    "updateTestik",
    {
      tableId,
      testik,
      player: playerKey,
    },
    (response) => {
       
    }
  );
}, [testik, tableId, playerColor]);






//Закоментил 24 ноября не понимаю что делает этот код
// useEffect(() => {
//   socket.on("testikUpdated", (data) => {
//     const { player, testik: newTestik } = data;
//     if (player === (playerColor === "white" ? "player1" : "player2")) {
//       setTestik(newTestik);
//       // console.log("Значение testik обновлено из сокета:", newTestik);
//     }
//   });

//   return () => {
//     socket.off("testikUpdated");
//   };
// }, [playerColor]);





// useEffect(() => {
//   // Устанавливаем флаг для отслеживания первого вызова
//   let isInitialLoad = true;

//   if (!socket.connected) {
//     socket.connect();
//   }

//   const handleGameData = (gameData) => {
//     if (isInitialLoad) {
     
//       updateGame(gameData); // Обновление состояния игры только при первом получении данных
//       isInitialLoad = false; // После первого вызова сбрасываем флаг
//     }
//   };

//   socket.once('connect', () => {
//     // Запрашиваем данные игры только один раз при подключении
//     socket.emit('fetchGameData', tableId);
//   });

//   socket.on('gameDataResponse', handleGameData);

//   return () => {
//     socket.off('gameDataResponse', handleGameData);
//   };
// }, [tableId]);

useEffect(() => {
  if (!socket.connected) {
    socket.connect();
  }
  let isInitialLoad = true;
  const handleGameData = (gameData) => {
    if (isInitialLoad) {
      // Если это первый вызов, обновляем игру и сбрасываем флаг
      if (gameData && gameData.table_id === parseInt(tableId, 10)) {
        updateGame(gameData);
        setRolledDice((gameData.current_turn === 'player1' ? gameData.player1_rolls : gameData.player2_rolls)?.slice(-1)[0] || []);
        isInitialLoad = false;
      }
    } else {
      // Если это повторный вход, также обновляем состояние
   
      if (gameData && gameData.table_id === parseInt(tableId, 10)) {
        updateGame(gameData);
        setRolledDice((gameData.current_turn === 'player1' ? gameData.player1_rolls : gameData.player2_rolls)?.slice(-1)[0] || []);
      }
    }
  };

  const fetchData = () => {
    // Запрашиваем данные игры при каждом монтировании компонента
    socket.emit('fetchGameData', tableId);
  };

  // Выполняем запрос данных
  fetchData();

  // Подключаем обработчик для gameDataResponse
  socket.on('gameDataResponse', handleGameData);

  return () => {
    socket.off('gameDataResponse', handleGameData);
  };
}, [tableId]);
 

const updateTestikOnServer = async () => {
 
  try {
    // Определяем, какой игрок обновляет testik
    const playerKey = playerColor === 'white' ? 'player1' : 'player2';

    // Отправляем обновленное значение testik на сервер с указанием игрока
    await axios.post(`http://${process.env.REACT_APP_API_URL}:5000/api/games/${tableId}/updateTestik`, {
      testik: testik,
      player: playerKey
    });
  
  } catch (error) {
    console.error('Ошибка при обновлении testik на сервере:', error);
  }
};









  useEffect(() => {
    socket.on('startCountdown', ({ tableId }) => {
      // Проверяем, что это наш стол и таймер еще не запущен
      if (parseInt(tableId, 10) === parseInt(tableId, 10) && !countdownInterval.current) {
        setShowReadyButton(true); // Показываем кнопку "Готов"
        setCountdown(10); // Устанавливаем начальное значение отсчета
  
        // Запускаем таймер отсчета, только если еще не был запущен
        countdownInterval.current = setInterval(() => {
          setCountdown((prevCountdown) => {
            if (prevCountdown <= 1) {
              clearInterval(countdownInterval.current); // Очищаем таймер при завершении
              countdownInterval.current = null;
              setShowReadyButton(true); // Скрываем кнопку "Готов"
              return 0; // Возвращаем ноль, чтобы показать завершение отсчета
            }
  
            return prevCountdown - 1; // Уменьшаем счетчик на одну секунду
          });
        }, 1000);
      }
    });
  
    return () => {
      // Очищаем таймер при размонтировании компонента
      if (countdownInterval.current) {
        clearInterval(countdownInterval.current);
        countdownInterval.current = null;
      }
    };
  }, [game, tableId]);
  

  


  useEffect(() => {
    socket.on('startCountdown', ({ tableId }) => {
      // Проверяем, что это наш стол и таймер еще не запущен
      if (parseInt(tableId, 10) === parseInt(tableId, 10) && !countdownInterval.current) {
        setShowReadyButton(true); // Показываем кнопку "Готов"
        setCountdown(10); // Устанавливаем начальное значение отсчета
  
        // Запускаем таймер отсчета, только если еще не был запущен
        countdownInterval.current = setInterval(() => {
          setCountdown((prevCountdown) => {
            if (prevCountdown <= 1) {
              clearInterval(countdownInterval.current); // Очищаем таймер при завершении
              countdownInterval.current = null;
              setShowReadyButton(false); // Скрываем кнопку "Готов"
              return 0; // Возвращаем ноль, чтобы показать завершение отсчета
            }
  
            return prevCountdown - 1; // Уменьшаем счетчик на одну секунду
          });
        }, 1000);
      }
    });
  
    return () => {
      // Очищаем таймер при размонтировании компонента
      if (countdownInterval.current) {
        clearInterval(countdownInterval.current);
        countdownInterval.current = null;
      }
    };
  }, [game, tableId]);
  





//Отключил из за ненадобности Я так понял тут лишний счетчик  сервера приходил, теперь он не нужен, так как при выходе второго игрока у первого сразу счетчик исчезает
  // useEffect(() => {
  //   socket.on('resetCountdown', ({ tableId }) => {
  //     if (parseInt(tableId, 10) === parseInt(tableId, 10)) {
  //       if (countdownInterval.current) {
  //         clearInterval(countdownInterval.current); // Останавливаем интервал
  //         countdownInterval.current = null;
  //       }
  //       setCountdown(0); // Сбрасываем значение отсчета
  //       setShowReadyButton(false); // Скрываем кнопку "Готов"
  //       setOpponentName('Ожидание второго игрока')
  //       updateGame((prevGame) => {
  //         if (prevGame) {
  //           // Определяем, кто именно вышел из игры
  //           if (prevGame.player1_name === username) { 
  //             return { ...prevGame, player2_name: '' };
  //           } else if (prevGame.player2_name === username) {
  //             return { ...prevGame, player1_name: '' };
  //           }
  //         }
        
  //         return prevGame;
          
  //       });
  //     }
  //   });
  
  //   return () => {
  //     // Очищаем таймер при размонтировании компонента
  //     if (countdownInterval.current) {
  //       clearInterval(countdownInterval.current);
  //       countdownInterval.current = null;
  //     }
  //   };
  // }, [tableId]);
  

  // useEffect(() => {





  

    
//   socket.on('resetCountdown', ({ tableId }) => {
// console.log('77787879778');

 

//     if (parseInt(tableId, 10) === parseInt(tableId, 10)) {
//       if (countdownInterval.current) {
//         clearInterval(countdownInterval.current); // Останавливаем интервал
//         countdownInterval.current = null;
//       }
//       setCountdown(0); // Сбрасываем значение отсчета
//       setShowReadyButton(false); // Скрываем кнопку "Готов"
//       setOpponentName('Ожидание второго игрока');
//       updateGame((prevGame) => {
//         if (prevGame) {
//           if (prevGame.player1_name === username) {
//             return { ...prevGame, player2_name: '' };
//           } else if (prevGame.player2_name === username) {
//             return { ...prevGame, player1_name: '' };
//           }
//         }
//         return prevGame;
//       });
      
//     }
//   });

//   return () => {
//     if (countdownInterval.current) {
//       clearInterval(countdownInterval.current);
//       countdownInterval.current = null;
//     }
//   };
// }, [tableId]);

useEffect(() => {
  socket.on('resetCountdown', ({ tableId }) => {
  
    socket.emit('resetCountdown', { tableId, player: username });
    // 1. Останавливаем локальный таймер обратного отсчёта
    if (countdownInterval.current) {
      clearInterval(countdownInterval.current);
      countdownInterval.current = null;
    }

    // 2. Сбрасываем счётчик
    setCountdown(0); 
    setShowReadyButton(false); 
    setOpponentName(i18n.t('game.common.waitingSecondPlayer'));

    // 3. Обновляем локальное состояние game, чтобы убрать оппонента
    updateGame((prevGame) => {
      if (!prevGame) return prevGame;
      // Если я - player1, тогда оппонент = player2
      // Убираем player2_name из локального state
      if (prevGame.player1_name === username) {
        return { ...prevGame, player2_name: '' };
      } 
      // Иначе, если я - player2, убираем player1_name
      else if (prevGame.player2_name === username) {
        return { ...prevGame, player1_name: '' };
      }
      return prevGame;
    });



     // 4. Удаляем стол из локального состояния и localStorage
     setTableStates((prevStates) => {
      const updatedStates = { ...prevStates };

      
      delete updatedStates[tableId]; // Удаляем конкретный стол
     
      localStorage.setItem('tableStates', JSON.stringify(updatedStates)); // Сохраняем изменения в локальном хранилище
      return updatedStates;
    });
  });

  return () => {
    // Чтобы на размонтировании убрать подписку
    socket.off('resetCountdown');
    if (countdownInterval.current) {
      clearInterval(countdownInterval.current);
      countdownInterval.current = null;
    }
  };
}, [tableId]);









  useEffect(() => {
    if (game) {
      const opponent = playerColor === 'white' ? game.player2_name : game.player1_name;

      setOpponentName(opponent || i18n.t('game.common.waitingOpponent'));
    }
  }, [game, playerColor]); // Зависимости: обновление при изменении game или playerColor








//Рабочий код, без многостоловости
// useEffect(() => {
//    // Убедимся, что сокет подключен
//    if (!socket.connected) {
//     socket.connect();
//   }
// // При монтировании компонента присоединяемся к столу
// if (!hasJoinedTableRef.current && socket.connected) {
//   hasJoinedTableRef.current = true; // Устанавливаем значение в true, чтобы не вызывать повторно

//   socket.emit('reconnectToTable', { tableId, player: username });
// // socket.emit('joinTable', { tableId, player: username });
// // console.log('joinTable',{ tableId, player: username }); 

// hasJoinedTableRef.current = true; // Устанавливаем значение в true, чтобы не вызывать повторно
// //  setHasJoinedTable(true);
//   // После присоединения запрашиваем данные игры
//   socket.emit('fetchGameData', tableId);
 

//   // Обработчик получения уникального ID игрока от сервера
// socket.on('playerId', ({ id }) => {

//   // Сохраните ID игрока, если это необходимо
// });
// }
//   // Обработчик события получения данных игры
//   socket.on('gameDataResponse', (gameData) => {
//     if (!gameData) return <div>Загрузка данных игры...</div>;
//     if (gameData && gameData.table_id === parseInt(tableId, 10)) {
//       updateGame(gameData);
//       // Дополнительная логика по обновлению состояния
//     }
//   });



//   socket.on('gameUpdated', (updatedGame1) => {
   
    
//     if (updatedGame1.table_id === parseInt(tableId, 10)) {
//       updateGame(updatedGame1);
//       setMoves(updatedGame1.moves || []);
//       setCurrentTurn(updatedGame1.current_turn); // Обновление currentTurn
//       if (game && game.board_state) {
      
//       } else {
      
//       }
     
//          // Определяем цвет игрока и обновляем testik только для текущего игрока
//   if (playerColor === 'white') {
//     // Если игрок белый, обновляем его состояние testik
//     setTestik(updatedGame1.testik_player1);
//   } else if (playerColor === 'black') {
//     // Если игрок черный, обновляем его состояние testik
//    setTestik(updatedGame1.testik_player2);
//   }

     
    
      
//       if (updatedGame1.player1_name === username) {
//         setPlayerColor('white');
//       } else if (updatedGame1.player2_name === username) {
//         setPlayerColor('black');
//       }
     
//     }
//   });

//   socket.on('startGameMessage', ({ tableId, player1Roll, player2Roll, currentTurn, boardState }) => {
//     setShowReadyButton(false); 
//     setShowModal(true);
//     setTimeout(() => setShowModal(false), 2000);
//     setTimer(null);
//     updateGame((prevGame) => ({
//       ...prevGame,
//       player1Roll,
//       player2Roll,
//       currentTurn,
//       boardState,
//     }));
  
//   });

//   // socket.on('playerReadyStatus', ({ tableId: id, player1Ready, player2Ready }) => {
  
//   //   if (id === parseInt(tableId, 10)) {
//   //     updateReadyStatus('player1', Boolean(player1Ready));
//   //     updateReadyStatus('player2', Boolean(player2Ready));
     
//   //   }
//   // });
//   socket.on('playerReadyStatus', ({ tableId: id, player1Ready, player2Ready }) => {
//     console.log(`Получено событие playerReadyStatus для стола ${id}`);
//     console.log(`Игрок 1 готов: ${player1Ready}, Игрок 2 готов: ${player2Ready}`);
    
//     if (id === parseInt(tableId, 10)) {
//       console.log('Обновляем статус готовности для игроков на клиенте');
//       updateReadyStatus('player1', Boolean(player1Ready));
//       updateReadyStatus('player2', Boolean(player2Ready));
  
//       // Если оба игрока готовы, активируем кнопку первого броска
//       if (player1Ready && player2Ready) {
//         console.log('Оба игрока готовы, устанавливаем rollEnabled в true');
//         setRollEnabled(true);
//       }
//     }
//   });
  
 

// socket.on('diceRolled', ({ tableId, currentPlayer, diceValues, numberMove,shetchik,flagFirst }) => {
// console.log('отпра',{ tableId, currentPlayer, diceValues, numberMove });

// setShetchik((prev) => prev + shetchik);
// if (flagFirst !== undefined) {
//   setFlagFirst(flagFirst);
//   localStorage.setItem('flagFirst', flagFirst); // Сохраняем для восстановления после перезагрузки
 
// }
  
// // Проверяем, выпали ли дубли (куш)
// let movesCount;
// let rolledDiceValues;

// if (diceValues[0] === diceValues[1]) {
//  console.log('кубики',);
 
//   // Выпали дубли (куш)
//   movesCount = 4; // Устанавливаем 4 хода
//   rolledDiceValues = [diceValues[0], diceValues[0], diceValues[0], diceValues[0]]; // Четыре одинаковых значения
// } else {
//   // Обычный бросок
//   movesCount = 2; // Устанавливаем 2 хода
//   rolledDiceValues = diceValues; // Два значения кубиков
// }

// // Устанавливаем количество ходов для текущего игрока
//  setNumberMove(numberMove || movesCount); // Используем значение `numberMove` от сервера, если оно есть
// setRolledDice(rolledDiceValues); // Устанавливаем значения кубиков
// setHasRolledDice(true)
// // Обновляем текущий ход в состоянии игры
// updateGame((prevGame) => ({
//   ...prevGame,
//   current_turn: currentPlayer
// }));

// });



//   socket.on('firstRollStatus', ({ tableId, player1Roll, player2Roll }) => {
  
//     setFirstRolls({ player1Roll, player2Roll });
//     if (player1Roll !== null && player2Roll !== null) {
//       if (player1Roll > player2Roll) {
//         setCurrentTurn('player1');
//          setRollEnabled(false);
//          setFirstMoveComplete(true);
      
//       } else if (player1Roll < player2Roll) {
//         setCurrentTurn('player2');
//          setRollEnabled(false);
//         setFirstMoveComplete(true);
      
//       } else {
//         setFirstRolls({ player1Roll: player1Roll, player2Roll: player2Roll });
//           setRollEnabled(true);
      
//       }
//     }

//   });

//   return () => {
//     // socket.disconnect();
//     socket.off('gameUpdated');
//     socket.off('playerId');
//     socket.off('startGameMessage');
//     socket.off('playerReadyStatus');
//     socket.off('startCountdown');
//     socket.off('diceRolled');
//     socket.off('firstRollStatus');
//   };
// }, [tableId, username,hasRolledDice]);



socket.on('firstDiceRolledplayer2', ({ tableId, currentPlayer, diceValues, numberMove }) => {
  setRolledDice(diceValues);
  setCurrentTurn(currentPlayer);
  setNumberMove(numberMove);
  setHasRolledDice(true);

});

//Для многостоловости, возможны баги, надо тестить!!!
useEffect(() => {
  // Убедимся, что сокет подключен
  if (!socket.connected) {
    socket.connect();
  }

  // При монтировании компонента присоединяемся к столу
  if (!hasJoinedTableRef.current && socket.connected) {
    hasJoinedTableRef.current = true; // Устанавливаем значение в true, чтобы не вызывать повторно

    // Используем событие reconnectToTable вместо joinTable, если это необходимо
    socket.emit('reconnectToTable', { tableId, player: username });
    // Если нужно использовать joinTable, раскомментируйте следующие строки:
    // socket.emit('joinTable', { tableId, player: username });
    // console.log('joinTable',{ tableId, player: username }); 

    // После присоединения запрашиваем данные игры
    socket.emit('fetchGameData', tableId);

    // Обработчик получения уникального ID игрока от сервера
    socket.on('playerId', ({ id }) => {
      // Сохраните ID игрока, если это необходимо
    });
  }

  // Обработчик события получения данных игры
  const handleGameDataResponse = (gameData) => {
    if (!gameData) return <div>{i18n.t('game.common.loadingGameData')}</div>;
    if (gameData && gameData.table_id === parseInt(tableId, 10)) {
      updateGame(gameData);
      // Дополнительная логика по обновлению состояния
    }
  };

  socket.on('gameDataResponse', handleGameDataResponse);

  // Обработчик события обновления игры
  const handleGameUpdated = (updatedGame1) => {
    if (updatedGame1.table_id === parseInt(tableId, 10)) {
      updateGame(updatedGame1);
      setMoves(updatedGame1.moves || []);
      setCurrentTurn(updatedGame1.current_turn); // Обновление currentTurn

      // Определяем цвет игрока и обновляем testik только для текущего игрока
      if (playerColor === 'white') {
        // Если игрок белый, обновляем его состояние testik
        setTestik(updatedGame1.testik_player1);
      } else if (playerColor === 'black') {
        // Если игрок черный, обновляем его состояние testik
        setTestik(updatedGame1.testik_player2);
      }

      // Определяем цвет игрока на основе имени
      if (updatedGame1.player1_name === username) {
        setPlayerColor('white');
      } else if (updatedGame1.player2_name === username) {
        setPlayerColor('black');
      }
    }
  };

  socket.on('gameUpdated', handleGameUpdated);

  // Обработчик события начала игры
  const handleStartGameMessage = ({ tableId, player1Roll, player2Roll, currentTurn, boardState }) => {
    setShowReadyButton(false); 
    setShowModal(true);
    setTimeout(() => setShowModal(false), 2000);
    setTimer(null);
    updateGame((prevGame) => ({
      ...prevGame,
      player1Roll,
      player2Roll,
      currentTurn,
      boardState,
    }));
  };

  socket.on('startGameMessage', handleStartGameMessage);

  // Обработчик статуса готовности игроков
  const handlePlayerReadyStatus = ({ tableId: id, player1Ready, player2Ready }) => {
 
  
    
    if (id === parseInt(tableId, 10)) {
     
      updateReadyStatus('player1', Boolean(player1Ready));
      updateReadyStatus('player2', Boolean(player2Ready));

      // Если оба игрока готовы, активируем кнопку первого броска
      if (player1Ready && player2Ready) {
    
        // setRollEnabled(true);
        setFirstRollComplete(true)
      }
    }
  };

  socket.on('playerReadyStatus', handlePlayerReadyStatus);

  // Обработчик события diceRolled с проверкой tableId
  const handleDiceRolled = ({ tableId: eventTableId, currentPlayer, diceValues, numberMove, shetchik, flagFirst,noMoves }) => {
    console.log('Второй игрок получил событие что оппонент бросил кубики',{ tableId: eventTableId, currentPlayer, diceValues, numberMove, shetchik, flagFirst,noMoves });

    // Проверяем, относится ли событие к этому столу
    if (eventTableId !== parseInt(tableId, 10)) return;

    // Логирование для отладки
  
    if (noMoves) {
      console.log('Нет доступных ходов. Переход хода.');
      // setNumberMove(0);
      setHasRolledDice(false);
      return;
    }
    setShetchik((prev) => prev + shetchik);
    if (flagFirst !== undefined) {
      setFlagFirst(flagFirst);
      localStorage.setItem('flagFirst', flagFirst); // Сохраняем для восстановления после перезагрузки
    }

    // Проверяем, выпали ли дубли (куш)
    let movesCount;
    let rolledDiceValues;

    if (diceValues[0] === diceValues[1]) {
     

      // Выпали дубли (куш)
      movesCount = 4; // Устанавливаем 4 хода
      rolledDiceValues = [diceValues[0], diceValues[0], diceValues[0], diceValues[0]]; // Четыре одинаковых значения
    } else {
      // Обычный бросок
      movesCount = 2; // Устанавливаем 2 хода
      rolledDiceValues = diceValues; // Два значения кубиков
    }

    // Устанавливаем количество ходов для текущего игрока
    setNumberMove(numberMove || movesCount); // Используем значение `numberMove` от сервера, если оно есть
    setRolledDice(rolledDiceValues); // Устанавливаем значения кубиков
    setHasRolledDice(true);

    // Обновляем текущий ход в состоянии игры
    updateGame((prevGame) => ({
      ...prevGame,
      current_turn: currentPlayer
    }));
  };

  socket.on('diceRolled', handleDiceRolled);

  // Обработчик события firstRollStatus
//   const handleFirstRollStatus = ({ tableId: eventTableId, player1Roll, player2Roll }) => {
//     setFirstRolls({ player1Roll, player2Roll });
//     // Проверяем, относится ли событие к текущему столу
// if (parseInt(tableId, 10) !== parseInt(eventTableId, 10)) return;

//     if (player1Roll !== null && player2Roll !== null) {
//       if (player1Roll > player2Roll) {
//         setCurrentTurn('player1');
//         setRollEnabled(false);
//         setFirstMoveComplete(true);
//       } else if (player1Roll < player2Roll) {
//         setCurrentTurn('player2');
//         setRollEnabled(false);
//         setFirstMoveComplete(true);
//       } else {
//         setFirstRolls({ player1Roll: player1Roll, player2Roll: player2Roll });
//         setRollEnabled(true);
//       }
//     }
//   };




const handleFirstRollStatus = ({ tableId: eventTableId, player1Roll, player2Roll }) => {
  // Проверяем, относится ли событие к текущему столу
  if (parseInt(eventTableId, 10) !== parseInt(tableId, 10)) return;

  // Обновляем значения первого броска
  setFirstRolls({ player1Roll, player2Roll });

  // Логика определения текущего игрока
  if (player1Roll !== null && player2Roll !== null) {
    if (player1Roll > player2Roll) {
      setCurrentTurn('player1');
      setRollEnabled(false);
      setFirstMoveComplete(true);

      // Устанавливаем кубики только для текущего игрока
      if (playerColor === 'white') {
        setRolledDice([player1Roll]);
      }
    } else if (player1Roll < player2Roll) {
      setCurrentTurn('player2');
      setRollEnabled(false);
      setFirstMoveComplete(true);

      // Устанавливаем кубики только для текущего игрока
      if (playerColor === 'black') {
        setRolledDice([player2Roll]);
      }
    } else {
      // В случае равенства
      setFirstRolls({ player1Roll, player2Roll });
      setRollEnabled(true);
    }
  }
};

  socket.on('firstRollStatus', handleFirstRollStatus);

  // Очистка обработчиков при размонтировании компонента
  return () => {
    socket.off('gameUpdated', handleGameUpdated);
    socket.off('playerId', handleGameDataResponse);
    socket.off('startGameMessage', handleStartGameMessage);
    socket.off('playerReadyStatus', handlePlayerReadyStatus);
    socket.off('diceRolled', handleDiceRolled);
    socket.off('firstRollStatus', handleFirstRollStatus);
  };
}, [tableId, username, hasRolledDice]);












// useEffect(() => {
//   if (!hasJoinedTable) {
//     socket.emit('joinTable', { tableId, player: username });
//     setHasJoinedTable(true);
//   }
// }, [hasJoinedTable, tableId, username]);





  useEffect(() => {
    if (timer !== null && timer > 0) {
      const timerId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(timerId);
    } else if (timer === 0) {
      socket.emit('leaveTable', { tableId, player: username });
      navigate('/');
    }
  }, [timer, tableId, navigate, username]);

  const sendMove = (move) => {
 
    if (rolledDice.length === 0) {
      console.error(translate('game.short.rollFirst'));
      return;
    }

    socket.emit('makeMove', { tableId, move, currentPlayer: game.current_turn });
  };

  // const handleReadyClick = () => {
   
  //   socket.emit('playerReady', { tableId, player: username });
  //   updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
  //   setShowReadyButton(false);
  // };

//   const handleReadyClick = () => {
//     socket.emit('playerReady', { tableId, player: username });
//     updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
//     setShowReadyButton(false);
//   };
// console.log('готов',updateReadyStatus);
const handleReadyClick = () => {
  
  socket.emit('playerReady', { tableId, player: username });
  updateReadyStatus(playerColor === 'white' ? 'player1' : 'player2', true);
  setShowReadyButton(false);

  // Проверка, если оба игрока готовы, включаем возможность для броска кубиков
  if (readyStatus.player1 && readyStatus.player2) {
    
    
    setRollEnabled(true);
    setFirstRollComplete(true)
    updateFirstRollEnabledOnServer(true); // Обновляем состояние на сервере, что бросок кубиков включен
  }
};

  
  // const handleFirstRollClick = () => {
   
  //   socket.emit('firstRollDice', { tableId, player: username });
  //   setFlagTestik(true)
  //    setRollEnabled(false);
     
  // };


  useEffect(() => {
    // Принимаем сигнал от сервера о ничьей
    socket.on('bothPlayersReady', ({ tableId }) => {
     

      // Сбрасываем значения бросков
      
      setFirstRollComplete(true) 
    });

    return () => {
      socket.off('bothPlayersReady'); // Удаляем слушатель при размонтировании
    };
  }, []);




  const handleFirstRollClick = () => {
    socket.emit('firstRollDice', { tableId, player: username });
    setFirstRollComplete(false) 
    // setFlagTestik(true);
    // setRollEnabled(false);
    // updateFirstRollEnabledOnServer(false); // Обновляем состояние на сервере
  };
  

  const handleLeaveClick = () => {
    
     // При покидании стола -> decrement openTableCount
     socket.emit('decrementOpenTableCount', { tableId, username });
    socket.emit('leaveTable', { tableId, player: username });
    // navigate('/');
    navigate('/', { state: { fromGame: true } }); // Передаём состояние
    updateTableState(tableId, { isClosed: true, isMinimized: false });
  
    setTimeout(() => {
    
    }, 0); // Используем `setTimeout`, чтобы дождаться обновления состояния
  
    // Явно сбрасываем каждое состояние
    setPlayerColor(null);
    setCurrentTurn(null);
    setHasRolledDice(false);
    setRolledDice([]);
    setShowReadyButton(false);
    setCountdown(0);
    setOpponentName(i18n.t('game.common.waitingSecondPlayer'));
    setFirstRolls({ player1Roll: null, player2Roll: null });
    setRollEnabled(false);
    setFirstMoveComplete(false);
    setTestik(false);
    setFlagFirst(0);
    setShetchik(0);
  
    // Очищаем localStorage
    localStorage.removeItem('flagFirst');
    localStorage.removeItem('shetchik');
  };
  
  // const handleLeaveClick = () => {
  //   socket.emit('leaveTable', { tableId, player: username });
  //   navigate('/');
  // };

  // Обработчик события для удаления игрока, который не нажал на "Готов"
// socket.on('playerLeft', ({ tableId, player }) => {
//   if ((player === 'player1' && playerColor === 'white') || (player === 'player2' && playerColor === 'black')) {
//       navigate('/'); // Перенаправляем только если текущий игрок не нажал "Готов"
//   }
// });




// Обработчик playerLeft для обновления стола и отображения кнопки "Присоединиться"
socket.on('playerLeft', ({ tableId, player }) => {
  // Очищаем данные об оппоненте для оставшегося игрока
  if ((player === 'player1' && playerColor === 'white') || (player === 'player2' && playerColor === 'black')) {
    navigate('/')
    // Если текущий игрок остался за столом, обновляем его интерфейс для ожидания нового игрока
      setOpponentName(i18n.t('game.common.waitingSecondPlayer'));
      
      // setShowJoinButton(true); // Показать кнопку "Присоединиться"
  }
});


  const handleRollDiceClick = () => {


    if (hasRolledDice) {
      
      return;
    }

    setShetchik(prevShetchik => prevShetchik + 1)
    
    setFlagTestik(true)
    setHasRolledDice(true)
    setFirstRollComplete(true)
    // setTestik(true)
    // Увеличиваем flagFirst и сохраняем его в localStorage
    // setFlagFirst((prevFlagFirst) => {
    //   const newFlagFirst = prevFlagFirst + 1;
    //   localStorage.setItem("flagFirst", newFlagFirst);
   
    console.log('Первый игрок отправил событие бросил кубики',{ tableId: game.table_id, currentPlayer: currentTurn,shetchik});

    // socket.emit('rollDice', { tableId: game.table_id, currentPlayer: currentTurn,testik: true,shetchik});
    socket.emit('rollDice', { tableId: game.table_id, currentPlayer: currentTurn,shetchik});
  // })
  };

// До о1
  // const handleConfirmMove = () => {
  //   setNumberMove(2); // Or set to 0 if appropriate
    
    
  //   socket.emit('confirmMove', { tableId: game.table_id, player: currentTurn, boardState: JSON.stringify(game.board_state) });
  //   const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
   
    
  //   // setTestik(false); // Скрываем кнопку "Бросить кубики" для текущего игрока
  //   setCurrentTurn(nextTurn); // Устанавливаем следующий ход
  //   setRolledDice([]); // Обнуляем значения кубиков для следующего игрока
    
  // };


  
  // const handleConfirmMove = () => {
  //   setNumberMove(2); // Or set to 0 if appropriate
   
  //   socket.emit('confirmMove', { tableId: game.table_id, player: currentTurn, boardState: JSON.stringify(game.board_state) });
  //   const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
    
  //   setCurrentTurn(nextTurn); // Устанавливаем следующий ход
  //   setRolledDice([]); // Обнуляем значения кубиков для следующего игрока
  //   setFirstMoveComplete(true) 
  //   // setHasRolledDice(false); // Сбрасываем состояние броска кубиков для следующего хода
  // };
  
  // useEffect(() => {
  //   if (currentTurn && isTestikLoaded) { // Проверяем, что данные загружены и есть текущий ход
  //     const isMyTurn = currentTurn === (playerColor === 'white' ? 'player1' : 'player2');
  
  //     // Проверка перед установкой `testik`
  //     console.log("Проверка перед изменением testik:", {
  //       testik,
  //       isMyTurn,
  //       hasRolledDice,
  //       isTestikLoaded
  //     });
  
  //     // Устанавливаем `testik` на true, если это наш ход и кубики еще не брошены, и `testik` изначально false
  //     if (testik === false && isMyTurn && !hasRolledDice) {
  //       console.log("Устанавливаем testik на true, так как это наш ход и кубики еще не брошены");
  //       setTestik(true);
  //     }
  //   }
  // }, [currentTurn, playerColor, hasRolledDice, isTestikLoaded]);
  
  // Логируем значение `testik` при каждом изменении
  // useEffect(() => {
  //   console.log("Текущее значение testik после обновления:", testik);
  // }, [testik]);
  
  
  

  // useEffect(() => {
  //   // Если страница обновлена и кубики не были брошены, то показываем кнопку броска
  //   if (!hasRolledDice) {
    
      
  //      setHasRolledDice(false) 
  //   }
  // }, [hasRolledDice]);

  useEffect(() => {
  

    const playerKey = playerColor === 'white' ? 'player1' : 'player2';
    // console.log(`Подготовка к отправке testik на сервер через сокет:`, {
    //     tableId,
    //     testik,
    //     player: playerKey
    // });

    // Отправка через сокет с логом для проверки на клиенте
    socket.emit('updateTestik', {
        tableId,
        testik,
        player: playerKey
    }, (response) => {
        // console.log('Ответ сервера на updateTestik:', response);
    });
}, [testik, tableId, playerColor]);







useEffect(() => {
  socket.on('testikUpdated', (data) => {
      const { player, testik: newTestik } = data;
      if (player === (playerColor === 'white' ? 'player1' : 'player2')) {
          setTestik(newTestik);
          // console.log('Значение testik обновлено из сокета:', newTestik);
      }
  });

  return () => {
      socket.off('testikUpdated');
  };
}, [playerColor]);





const updateFirstRollEnabledOnServer = (firstRollEnabled) => {
  const playerKey = playerColor === 'white' ? 'player1' : 'player2';
  socket.emit('updateFirstRollEnabled', {
    tableId,
    player: playerKey,
    firstRollEnabled
  });
};

 


useEffect(() => {
  // Эмитируем событие 'joinTable' при монтировании компонента Game
  socket.emit('reconnectToTable', { tableId, player: username });


  // Обработка события 'playerJoinedTable', если необходимо
  socket.on('playerJoinedTable', ({ tableId: joinedTableId, player }) => {
    if (joinedTableId === tableId && player === username) {
   
    }
  });

  return () => {
    socket.off('playerJoinedTable');
  };
}, [tableId, username]);






  useEffect(() => {
    
    if (currentTurn && flagTestik==true ) {
   
      
      // setRollEnabled(false)
       
      {
        const isMyTurn = currentTurn === (playerColor === 'white' ? 'player1' : 'player2');
        const newTestikValue = isMyTurn && hasRolledDice;
      
        
        // setRollEnabled(newTestikValue);
     
      } 
      
      
    }
   
  }, [currentTurn, playerColor, hasRolledDice]);
  

 // В компоненте Game, перед рендерингом TournamentMatch


if (!game) {
  return <div>{translate('game.common.loading')}</div>;
}

  
  return (
    <div className='bbb'>
       <button className="exitTable" onClick={handleLeaveClick}>{translate('game.short.leaveTable')}</button> 
      {/* <p>{testik.toString()}</p> */}
      {/* <h1>Игра {game.id}</h1>
      <div>Игрок 1: {game.player1_name}</div>
      <div>Игрок 2: {game.player2_name || 'Ожидание игрока 2'}</div> */}
      {/* <div>Ставка: {game?.bet}</div> */}
      {/* <div>Очки матча: {game?.match_points}</div>
      <div>Время матча: {game?.match_time}</div> */}
      {/* { <p>кнопка кубики {testik.toString()}</p> } */}
      {/* { <p>Бросил ли кубики 888888888888  {hasRolledDice.toString()}</p> } */}
      {/* { <p>Сейчас ход {currentTurn}</p> } */}
    {/* { <p>Testik 5555555555555 {testik.toString()}</p> } */}
     
      {/* { <p>Первый бросок 2 {firstMoveComplete.toString()}</p> } */}
    
     
   
     
          {/* {rollEnabled && !firstMoveComplete && (
            <button onClick={handleFirstRollClick}>Первый бросок</button>
          )} */}
           {/* {rollEnabled &&(
            <button onClick={handleFirstRollClick}>Первый бросок</button>
          )} */}
          {/* {rollEnabled && readyStatus.player1 && readyStatus.player2 && !firstRollComplete && (
  <button onClick={handleFirstRollClick}>Первый бросок</button>
)} */}

          {/* {rollEnabled && readyStatus.player1 && readyStatus.player2 && (
  <button onClick={handleFirstRollClick}>Первый бросок</button>
)} */}

      {/* <ShortBackgammonBoard
        moves={moves}
        sendMove={sendMove}
        playerColor={playerColor}
        // initialBoardState={game?.board_state}
        initialBoardState={game?.board_state || []} // Устанавливаем пустой массив, если данные отсутствуют
        currentTurn={currentTurn}
        diceRolls={rolledDice}
        handleConfirmMove={handleConfirmMove} // Передаем handleConfirmMove в ShortBackgammonBoard
        handleRollDiceClick={handleRollDiceClick} 
        handleFirstRollClick = {handleFirstRollClick}
        hasRolledDice = {hasRolledDice}
        setHasRolledDice = {setHasRolledDice} 
       
         /> */}

<ShortBackgammonBoard
  moves={moves}
  sendMove={sendMove}
  playerColor={playerColor}
  initialBoardState={game?.board_state || []}
  currentTurn={currentTurn}
  diceRolls={rolledDice}
  // handleConfirmMove={handleConfirmMove}
  handleRollDiceClick={handleRollDiceClick}
  handleFirstRollClick={handleFirstRollClick}
  hasRolledDice={hasRolledDice}
  setHasRolledDice={setHasRolledDice}
  firstMoveComplete={firstMoveComplete}
  firstRollComplete={firstRollComplete}
  isFirstMoveDone={isFirstMoveDone}
  firstRolls={firstRolls}
  numberMove={numberMove}
  showReadyButton = {showReadyButton}
  handleReadyClick = {handleReadyClick}
  readyStatus = {readyStatus}
  countdown = {countdown}
  opponentName = {opponentName}

  shetchik = {shetchik}
  setShetchik = {setShetchik}

  onCollapse={handleCollapse} token={token}
  tableId={currentTableId}
  setShowReadyButton = {setShowReadyButton}
  updateReadyStatus = {updateReadyStatus}
  updateFirstRollEnabledOnServer = {updateFirstRollEnabledOnServer}
  handleFirstRollStatus = {handleFirstRollStatus} 
  // ... other necessary props
/>

{/* <TournamentMatch
initialBoardState={game?.board_state || []}
playerColor={playerColor}
/>  */}
{/* <BoardDisplay 
  hasRolledDice={hasRolledDice}
  currentTurn={currentTurn}
  playerColor={playerColor}
  handleRollDiceClick={handleRollDiceClick}
  
/> */}
 {/* {game?.player1_name && game?.player2_name ? (
        <div>
          {showReadyButton && (
            <div>
              <button onClick={handleReadyClick} disabled={readyStatus.player1 && readyStatus.player2}>
                {readyStatus.player1 && readyStatus.player2 ? 'Ожидание начала игры...' : 'Готов'}
              </button>
              <div>Оставшееся время: {countdown}</div>
            </div>
          )}

        </div>
      ) : ( 
        <div>Ожидание оппонента...</div>
      )} */}
      {game?.player1_name && game?.player2_name && (
        <>
          <div>{translate('game.short.currentPlayer')} {currentTurn ? game[currentTurn + '_name'] : translate('game.short.waitingRoll')}</div>
          <div>{translate('game.short.opponent')} {opponentName}</div>
          
          {/* {!hasRolledDice && currentTurn === (playerColor === 'white' ? 'player1' : 'player2') && (
            <button className="roll-dice-button" onClick={handleRollDiceClick}>Бросить кубики</button>
          )} */}
           {/* <button onClick={handleRollDiceClick}>Бросить кубики</button> */}
          {/* {rollEnabled && currentTurn === (playerColor === 'white' ? 'player1' : 'player2') && (
  <button onClick={handleRollDiceClick}>Бросить кубики</button>
)} */}
{/* <button onClick={handleRollDiceClick}>Бросить кубики</button> */}
        
        </>
      )}
  {/* {rolledDice.length > 0 && (
            <div>
              <p>Значения кубиков: {rolledDice[0]}, {rolledDice[1]}</p>
            </div>
          )} */}
      {/* {showModal && <Modal message="Желаем удачи!" />} */}
     
    </div>




  );
};

export default Game;


